<template>
  <form class="ortic-form-horizontal">
    <o-card :title="$t('sandoz.kam_contract') + ' // ' + item.contract_no + ' // ' + (item.addresses.length > 0 ? item.addresses[0].company_name : '')" v-if="item">
      <div class="float-right mr-10" v-if="['KAM_APO', 'KAM_WHS', 'BIOS_KAM_APO', 'BIOS_KAM_WHS'].includes(item.type)">
        <a @click="downloadPreApproveExcel()" class="btn btn-primary ml-2" target="_blank">{{ $t('sandoz.pre_approval_check') }}</a>
      </div>
      <b-tabs class="inline-tabs" ref="tabs" v-model="activeTab">
        <b-tab :title="$t('sandoz.general')" active>

          <b-alert show variant="warning" v-if="item.approval_feedback">{{item.approval_feedback}}</b-alert>

          <b-row>
              <b-col>

                  <o-value-select :label="$t('sandoz.owner')" url="/api/system/users?filter%5Bactive%5D=1%25&filter%5Bis_kam_user%5D=1%25&sortBy=name&include=regions" value-field="id" text-field="name"
                                  v-model="item.user_id"  @input-object="setCurrentUser"></o-value-select>
                  <b-alert show variant="warning" v-if="currentUser && item.region_id === null">{{$t('sandoz.no_region_user')}}</b-alert>
                  <o-value-select :items="contractTypes" :label="$t('sandoz.type')" v-model="item.type"/>

                  <o-form-group :label="$t('sandoz.customer_external_id')" class="mb-2">
                      <b-input-group>
                          <input v-model="item.customer_external_id" type="text" class="form-control" disabled>
                          <b-input-group-append>
                              <b-btn variant="primary" @click.prevent="setMasterAddress">
                                <fa icon="ellipsis-h"/>
                              </b-btn>
                          </b-input-group-append>
                      </b-input-group>
                  </o-form-group>

                  <o-value-select :items="years" :title="$t('sandoz.contract_year')" v-model="item.contract_year"
                                  :label="$t('sandoz.contract_year')">
                  </o-value-select>

                  <o-input readonly v-model="item.contract_no_suffix" v-if="item.contract_no_suffix" :label="$t('sandoz.contract_no_suffix')"></o-input>

                  <o-form-group :label="$t('sandoz.new_customer')" class="new_customer_radio">
                    <div class="w-100 pl-4 d-flex">
                      <b-form-radio v-model="item.new_customer" name="new_customer" :disabled="readonly" value="x">{{$t('sandoz.yes')}}</b-form-radio>
                      <b-form-radio v-model="item.new_customer" name="new_customer" :disabled="readonly" :value="null">{{$t('sandoz.no')}}</b-form-radio>
                    </div>
                  </o-form-group>

                  <o-form-group :label="$t('sandoz.previous_contract')" class="mb-2"
                                v-if="item.new_customer === null || (this.changeExternalID && item.new_customer === null)"
                                :errorField="'previous_contract'" :class="item.new_customer === null && (item.previous_contract === undefined || item.previous_contract === null || item.previous_contract === '') ? 'has-error' : ''" >
                    <b-input-group>
                      <input :value="item.previous && item.previous.contract_no ? item.previous.contract_no : null"
                             type="text" class="form-control"  disabled>
                      <b-input-group-append>
                        <b-btn variant="primary" @click.prevent="$refs.addPreviousContractModel.show()">
                          <fa icon="ellipsis-h"/>
                        </b-btn>
                      </b-input-group-append>
                      <input v-model="item.previous_contract" type="hidden">
                    </b-input-group>
                  </o-form-group>

                  <hr>

                  <!--GX-->
                  <o-input v-if="fieldVisibility.turnoverGx" :errorField="'turnoverGx'" :label="biosContract ? $t('sandoz.turnover_bios') : $t('sandoz.turnover_gx')" v-model.number="item.turnover_gx" type="number" format="number" :description="formatDescription(this.getPlanDataTurnoverActual())"/>
                  <template v-if="fieldVisibility.turnoverDevelopmentGx">
                    <o-input class="mb-0" :errorField="'turnover_gx_expectation'" :label="biosContract ? $t('sandoz.turnover_bios_expectation') : $t('sandoz.turnover_gx_expectation')" v-model.number="item.turnover_gx_expectation" type="number" format="number" :description="formatDescription(item.plan_gx_turnover_expectation)" :descriptionClass="calculatePlanTurnOverExpectation()" />
                  </template>

                  <o-form-group :label="biosContract ? $t('sandoz.discount_bios') : $t('sandoz.discount_gx')" v-if="fieldVisibility.discountGx">
                    <b-container class="w-100 px-0">
                      <b-row>
                        <b-col>
                            <b-input-group append="%">
                              <o-input-percentage-control v-model.number="item.discount_gx_percentage"
                                                          :min="0.01" :max="99.99" :only-integer="false">
                              </o-input-percentage-control>
                            </b-input-group>
                            <small v-if="discount_percentage !== null " class="form-text text-muted">{{ discount_percentage | formatPricePercentage }}%</small>
                        </b-col>
                        <b-col>
                            <b-input-group prepend="CHF">
                              <b-form-input v-model.number="item.discount_gx" type="number" :disabled="true"></b-form-input>
                            </b-input-group>
                            <small v-if="item.plan_gx_target_discount" class="form-text" :class="calculatePlanTargetDiscount()">{{ item.plan_gx_target_discount | formatInteger }}</small>
                        </b-col>
                      </b-row>
                    </b-container>
                  </o-form-group>

                  <o-form-group v-if="fieldVisibility.discountGx">
                    <b-container class="w-100 px-0">
                      <b-row>
                        <b-col>
                          <b-form-checkbox v-model.lazy="item.is_discount_gx_accrual" name="accrual" :value="true">
                            {{ biosContract ? $t('sandoz.discount_bios_accrual') : $t('sandoz.discount_gx_accrual')}}
                          </b-form-checkbox>
                        </b-col>
                        <b-col>
                          <b-input-group prepend="CHF" v-if="item.is_discount_gx_accrual">
                            <input v-model="item.discount_gx_accrual" class="form-control" type="number"
                                   :class="{'is-invalid': item.is_discount_gx_accrual && isEmpty(item.discount_gx_accrual)}">
                            <b-input-group-append  v-if="item.status === 'Committed' || item.status === 'Approved' || item.status === 'Signed'">

                              <b-btn variant="primary" @click.prevent="setAccrual('GX')" :disabled="savingGXAccrual"
                                     :class="{'btn-block': !savingGXAccrual,'btn-loading': savingGXAccrual}">
                                {{  $t('core.save') }}
                              </b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </b-col>
                      </b-row>
                    </b-container>
                  </o-form-group>

                  <o-form-group :label="biosContract ? $t('sandoz.discount_bios_variable') : $t('sandoz.discount_gx_variable')" v-if="fieldVisibility.discountGxVariable">
                    <b-container class="w-100 px-0">
                      <b-row>
                        <b-col>
                            <b-input-group append="%">
                              <o-input-percentage-control v-model.number="item.discount_gx_variable_percentage"
                                                          :min="0.01" :max="99.99" :only-integer="false">
                              </o-input-percentage-control>
                            </b-input-group>
                        </b-col>
                        <b-col>
                            <b-input-group prepend="CHF">
                              <b-form-input v-model.number="item.discount_gx_variable" type="number" :disabled="true"></b-form-input>
                            </b-input-group>
                        </b-col>
                      </b-row>
                    </b-container>
                  </o-form-group>

                  <o-form-group :label="biosContract ? $t('sandoz.marketing_activities_total_bios') : $t('sandoz.marketing_activities_total_gx')" v-if="fieldVisibility.marketingActivitiesGx">
                    <b-container class="w-100 px-0">
                      <b-row>
                        <b-col>
                            <b-input-group append="%">
                              <o-input-percentage-control v-model.number="item.marketing_activities_gx_percentage"
                                                          :min="0.01" :max="99.99" :only-integer="false" :disabled="true">
                              </o-input-percentage-control>
                            </b-input-group>
                            <small v-if="marketing_activities_percentage !== null " class="form-text text-muted">{{ marketing_activities_percentage | formatPricePercentage }}%</small>
                        </b-col>
                        <b-col>

                          <b-input-group prepend="CHF">
                              <b-form-input v-model.number="item.marketing_activities_gx" type="number"></b-form-input>
                            </b-input-group>
                            <small v-if="item.plan_gx_target_invest" class="form-text" :class="calculatePlanTargetInvest()">{{ item.plan_gx_target_invest | formatInteger }}</small>
                        </b-col>
                      </b-row>
                    </b-container>
                  </o-form-group>

                  <div class="d-flex  align-items-center" v-if="fieldVisibility.advertisementGx || fieldVisibility.otherMarketingGx">
                    <div class="flex-fill">
                      <o-input v-if="fieldVisibility.advertisementGx" :errorField="'advertisement_gx'" :label="biosContract ? $t('sandoz.advertisement_bios') : $t('sandoz.advertisement_gx')" v-model.number="item.advertisement_gx" type="number"/>
                      <o-input v-if="fieldVisibility.otherMarketingGx" class="mb-0" :errorField="'other_marketing_gx'" :label="biosContract ? $t('sandoz.other_marketing_bios') : $t('sandoz.other_marketing_gx')" v-model.number="item.other_marketing_gx" type="number"/>
                    </div>
                    <div class="ml-2">
                      <b-button v-b-modal.kamAdvertismentInfo size="sm" type="button"><fa icon="info-circle"></fa></b-button>
                    </div>
                  </div>

                  <!--OTC-->
                  <template v-if="fieldVisibility.turnoverOtc">
                    <hr>
                    <o-input :errorField="'turnoverOtc'" :label="$t('sandoz.turnover_otc')" v-model.number="item.turnover_otc" type="number" format="number" :description="formatDescription(this.getPlanDataTurnoverActualOtc())"/>
                  </template>

                  <template v-if="fieldVisibility.turnoverDevelopmentOtc">
                    <o-input class="mb-0" :errorField="'turnover_otc_expectation'" :label="$t('sandoz.turnover_otc_expectation')" v-model.number="item.turnover_otc_expectation" type="number" format="number" :description="formatDescription(item.plan_otc_turnover_expectation)" :descriptionClass="calculatePlanTurnOverExpectationOtc()" />
                  </template>

                  <o-form-group :label="$t('sandoz.discount_otc')" v-if="fieldVisibility.discountOtc">
                    <b-container class="w-100 px-0">
                      <b-row>
                        <b-col>
                            <b-input-group append="%">
                              <o-input-percentage-control v-model.number="item.discount_otc_percentage"
                                                          :min="0.01" :max="99.99" :only-integer="false">
                              </o-input-percentage-control>
                            </b-input-group>
                            <small v-if="discount_percentage_otc !== null " class="form-text text-muted">{{ discount_percentage_otc | formatPricePercentage }}%</small>
                        </b-col>
                        <b-col>
                            <b-input-group prepend="CHF">
                              <b-form-input v-model.number="item.discount_otc" type="number" :disabled="true"></b-form-input>
                            </b-input-group>
                            <small v-if="item.plan_otc_target_discount" class="form-text" :class="calculatePlanTargetDiscountOtc()">{{ item.plan_otc_target_discount | formatInteger }}</small>
                        </b-col>
                      </b-row>
                    </b-container>
                  </o-form-group>

                  <o-form-group v-if="fieldVisibility.discountOtc">
                    <b-container class="w-100 px-0">
                      <b-row>
                        <b-col>
                          <b-form-checkbox v-model.lazy="item.is_discount_otc_accrual" name="accrual" :value="true">
                            {{$t('sandoz.discount_otc_accrual')}}
                          </b-form-checkbox>
                        </b-col>
                        <b-col>
                          <b-input-group prepend="CHF" v-if="item.is_discount_otc_accrual">
                            <input v-model="item.discount_otc_accrual" class="form-control" type="number"
                                   :class="{'is-invalid': item.is_discount_otc_accrual && isEmpty(item.discount_otc_accrual)}">
                            <b-input-group-append v-if="item.status === 'Committed' || item.status === 'Approved' || item.status === 'Signed'">
                              <b-btn variant="primary" @click.prevent="setAccrual('OTC')" :disabled="savingOTCAccrual"
                                     :class="{'btn-block': !savingOTCAccrual,'btn-loading': savingOTCAccrual}">
                                {{  $t('core.save') }}
                              </b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </b-col>
                      </b-row>
                    </b-container>
                  </o-form-group>

                  <o-form-group :label="$t('sandoz.marketing_activities_total_otc')" v-if="fieldVisibility.marketingActivitiesOtc">
                    <b-container class="w-100 px-0">
                      <b-row>
                        <b-col>
                            <b-input-group append="%">
                              <o-input-percentage-control v-model.number="item.marketing_activities_otc_percentage" :disabled="true"
                                                          :min="0.01" :max="99.99" :only-integer="false">
                              </o-input-percentage-control>
                            </b-input-group>
                            <small v-if="marketing_activities_percentage_otc !== null " class="form-text text-muted">{{ marketing_activities_percentage_otc | formatPricePercentage }}%</small>
                        </b-col>
                        <b-col>
                            <b-input-group prepend="CHF">
                              <b-form-input v-model.number="item.marketing_activities_otc" type="number"></b-form-input>
                            </b-input-group>
                            <small v-if="item.plan_otc_target_invest" class="form-text" :class="calculatePlanTargetInvestOtc()">{{ item.plan_otc_target_invest | formatInteger }}</small>
                        </b-col>
                      </b-row>
                    </b-container>
                  </o-form-group>

                  <div class="d-flex  align-items-center" v-if="fieldVisibility.advertisementOtc || fieldVisibility.otherMarketingOtc">
                    <div class="flex-fill">
                      <o-input v-if="fieldVisibility.advertisementOtc" :errorField="'advertisement_otc'" :label="$t('sandoz.advertisement_otc')" v-model.number="item.advertisement_otc" type="number"/>
                      <o-input v-if="fieldVisibility.otherMarketingOtc" :errorField="'other_marketing_otc'" :label="$t('sandoz.other_marketing_otc')" v-model.number="item.other_marketing_otc" type="number"/>
                    </div>
                    <div class="ml-2">
                      <b-button v-b-modal.kamAdvertismentInfo size="sm" type="button"><fa icon="info-circle"></fa></b-button>
                    </div>
                  </div>

                  <!--Turnover Generic-->
                  <o-input v-if="fieldVisibility.turnover" :errorField="'turnover'" :label="$t('sandoz.turnover')" v-model.number="item.turnover" type="number"/>

                  <template v-if="fieldVisibility.turnoverDevelopment">
                    <o-input class="mb-0" :errorField="'turnover_expectation'" :label="$t('sandoz.turnover_expectation')" v-model.number="item.turnover_expectation" type="number"/>
                  </template>

                  <o-form-group :label="$t('sandoz.discount')" v-if="fieldVisibility.discount">
                    <b-container class="w-100 px-0">
                      <b-row>
                        <b-col>
                            <b-input-group append="%">
                              <o-input-percentage-control v-model.number="item.discount_percentage"
                                                          :min="0.01" :max="99.99" :only-integer="false">
                              </o-input-percentage-control>
                            </b-input-group>
                        </b-col>
                        <b-col>
                            <b-input-group prepend="CHF">
                              <b-form-input v-model.number="item.discount" type="number" :disabled="true"></b-form-input>
                            </b-input-group>
                        </b-col>
                      </b-row>
                    </b-container>
                  </o-form-group>

                  <template v-if="fieldVisibility.marketingActivities && sortalysContract">
                    <o-form-group :label="$t('sandoz.marketing_activities')" v-if="fieldVisibility.marketingActivities">
                      <b-container class="w-100 px-0">
                        <b-row>
                          <b-col>
                              <b-input-group prepend="CHF">
                                <b-form-input v-model.number="item.marketing_activities_gx" type="number"></b-form-input>
                              </b-input-group>
                          </b-col>
                        </b-row>
                      </b-container>
                    </o-form-group>
                  </template>
                  <template v-else>
                    <o-form-group :label="$t('sandoz.marketing_activities_total')" v-if="fieldVisibility.marketingActivities">
                      <b-container class="w-100 px-0">
                        <b-row>
                          <b-col>
                              <b-input-group append="%">
                                <o-input-percentage-control v-model.number="item.marketing_activities_percentage" :disabled="true"
                                                            :min="0.01" :max="99.99" :only-integer="false">
                                </o-input-percentage-control>
                              </b-input-group>
                          </b-col>
                          <b-col>
                              <b-input-group prepend="CHF">
                                <b-form-input v-model.number="item.marketing_activities" type="number"></b-form-input>
                              </b-input-group>
                          </b-col>
                        </b-row>
                      </b-container>
                    </o-form-group>
                  </template>

                  <template v-if="fieldVisibility.turnoverDevelopment || fieldVisibility.turnoverDevelopmentOtc || fieldVisibility.turnoverDevelopmentGx">
                    <o-form-group label="" v-if="item.turnover_expectation">
                      <div class="w-100">
                        (
                          {{$t('sandoz.growth_forecast')}}
                          {{item.turnover_expectation - item.turnover | formatInteger}} /
                          {{(item.turnover_expectation / item.turnover - 1) * 100 | formatNumber}}%
                        )
                      </div>
                    </o-form-group>
                  </template>


                  <o-input v-if="fieldVisibility.contractValue" :label="$t('sandoz.contract_value')" v-model.number="item.marketing_activities" type="number"/>
                  <o-input v-if="fieldVisibility.contractDiscountValue" :label="$t('sandoz.contract_value')" v-model.number="item.discount" type="number"/>

                  <o-input v-if="fieldVisibility.advertisement" :errorField="'advertisement'" :label="$t('sandoz.advertisement')" v-model.number="item.advertisement" type="number"/>
                  <o-input v-if="fieldVisibility.otherMarketing" :errorField="'other_marketing'" :label="$t('sandoz.other_marketing')" v-model.number="item.other_marketing" type="number"/>

                  <o-input v-if="fieldVisibility.note" :errorField="'note'" :label="$t('sandoz.note')" v-model.number="item.note"/>

                </b-col>
                <b-col>
                  <o-value-select :items="languages" :label="$t('sandoz.language')" v-model="item.language"/>

                  <o-input :errorField="'file_link_1'" :label="$t('sandoz.link_contract_archive')" v-model="item.file_link_1" v-if="item.contract_year <= 2023"/>


                  <o-datepicker :typeable="true" :errorField="'contract_start'" :label="$t('sandoz.contract_start')" v-model="item.contract_start"/>
                  <o-datepicker :typeable="true" :errorField="'contract_expiration'" :label="$t('sandoz.contract_expiration')" v-model="item.contract_expiration"/>
                  <o-datepicker v-if="item.multiyear_contract" :typeable="true" :errorField="'multiyear_contract_expiration'" :label="$t('sandoz.multiyear_contract_expiration')" v-model="item.multiyear_contract_expiration"/>

                  <o-form-group v-if="fieldVisibility.checkboxMultiYearContract">
                      <b-form-checkbox v-model.lazy="item.multiyear_contract" name="multiyear_contract" :value="true">
                          {{$t('sandoz.multiyear_contract')}}
                      </b-form-checkbox>
                  </o-form-group>
                  <o-form-group v-if="fieldVisibility.checkboxDeliveryRequired">
                      <b-form-checkbox v-model.lazy="item.delivery_required" name="delivery_required" :value="true">
                          {{$t('sandoz.delivery_required')}}
                      </b-form-checkbox>
                  </o-form-group>
                  <o-form-group v-if="fieldVisibility.checkboxAvailableMarketingItems">
                      <b-form-checkbox v-model.lazy="item.available_marketing_items" name="available_marketing_items" :value="true">
                          {{$t('sandoz.available_marketing_items')}}
                      </b-form-checkbox>
                  </o-form-group>
                  <o-form-group v-if="fieldVisibility.checkboxDisclosureRequirement">
                      <b-form-checkbox v-model.lazy="item.disclosure_requirement" name="disclosure_requirement" :value="true">
                          {{$t('sandoz.disclosure_requirement')}}
                      </b-form-checkbox>
                  </o-form-group>
                  <!-- KUKO list -->
                  <div class="form-group mt-3" v-if="item && item.kukos && item.kukos.length > 0">
                    <label>{{ $t('sandoz.kuko_id') }}</label>
                    <div class="table-responsive mb-2">
                      <table class="table table-bordered table-sm table-hover mb-0 bg-white">
                        <thead class="thead-light">
                          <tr>
                            <th class="align-middle px-3 py-2 font-weight-bold">{{ $t('sandoz.kuko_id') }}</th>
                            <th class="align-middle px-3 py-2 font-weight-bold">{{ $t('sandoz.status') }}</th>
                            <th class="align-middle text-right px-3 py-2" style="width: 150px;">{{ $t('core.actions') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="kuko in item.kukos" :key="kuko.id">
                            <td class="align-middle px-3 font-weight-bold">{{ kuko.id }}</td>
                            <td class="align-middle px-3">{{ kuko.status }}</td>
                            <td class="align-middle text-right px-3 py-1">
                              <button class="btn btn-sm btn-outline-secondary" type="button" @click="openKuko(kuko.id)">
                                <fa icon="external-link-alt" class="mr-1"/>{{ $t('sandoz.open_kuko') }}
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <b-form-checkbox v-model="item.plan_deviation_skip_approval" value="true" v-if="checkPlanDeviationSkipApproval()" :disabled="readonly">{{$t('sandoz.plan_deviation_skip_approval_info')}}</b-form-checkbox>
                  <o-form-group :label="$t('sandoz.circulation')" class="mt-3">
                      <table class="table table-sm">
                        <template v-for="i in [1,2,3,4,5,6]">
                          <tr :key="i" v-if="item['approver_' + i]">
                            <td>{{item['approver_' + i]}}</td>
                            <td>
                              <span v-if="item['approval_person_' + i]" :title="item['approval_date_' + i]">
                                <fa icon="check"/> {{item['approval_person_' + i]}}
                              </span>
                              <span v-else>
                                -
                              </span>
                            </td>
                          </tr>
                        </template>
                      </table>
                  </o-form-group>
                  <o-textarea v-model="item.sales_rep_comment" :label="$t('sandoz.sales_rep_comment')" class="mt-3"></o-textarea>
                  <template v-if="user.is_super_user">
                    <o-textarea v-model="item.super_user_comment" :label="$t('sandoz.super_user_comment')" class="mt-3"
                                :error-field="'super_user_comment'"
                                :class="isCommentError && !item.super_user_comment ? 'has-error' : ''"></o-textarea>
                  </template>
              </b-col>
            </b-row>
          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.checklist')" v-if="fieldVisibility.tabChecklist && item.contract_year > 2023">
          <b-btn @click="downloadTemplate">{{$t('sandoz.download_template')}}</b-btn>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>{{$t('sandoz.icon')}}</th>
                  <th>{{$t('sandoz.check')}}</th>
                  <th>{{$t('sandoz.responsible')}}</th>
                  <th width="100">{{$t('sandoz.selected')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(check, checkIndex) in item.checks" :key="checkIndex">
                  <td>
                    <img :src="'/images/'+check.icon" width="50" height="50"/>
                  </td>
                  <td>
                    {{ check.check }}
                  </td>
                  <td>
                    {{ check.responsible }}
                  </td>
                  <td class="check-selected">
                    <o-checkbox v-model="check.selected" label=""/>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <b-modal ref="compCheckModal" :title="compCheckModalTitle" :ok-title="$t('sandoz.continue')" :ok-disabled="compDisableButtonCheck" @ok="addComplianceData" size="lg">
            <b-row v-if="complianceReviewBoard === true">
              <b-col>
                <p> {{ compCheckModalIntro }} {{ compCheckDeviation }}
                  <o-textarea-control v-model="item.compliance_deviation" rows="3" class="mt-0"></o-textarea-control>
                </p>
                <o-file-upload :label="$t('sandoz.minute_crb')+'*'" v-model="item.compilance_check_file" :allow-clear="true" :class="item.compilance_check_file === null ? 'has-error' : ''"
                  :allow-download="true">
                </o-file-upload>
              </b-col>
            </b-row>
            <b-row class="compliance-selection" v-if="complianceOnly === true">
              <b-col>
                <o-form-group>
                    <p> {{ compCheckPerformTitle }}</p>
                    <div class="w-100">
                      <b-form-radio v-model="complianceSelect" value="true">{{$t('sandoz.check_compliance_yes')}}</b-form-radio>
                      <b-form-radio v-model="complianceSelect" value="false">{{$t('sandoz.check_compliance_no')}}</b-form-radio>
                    </div>
                    <o-textarea v-model="item.compilance_check_note" rows="3" :class="(item.compilance_check_note === null || item.compilance_check_note === '') && complianceSelect === 'false' ? 'has-error' : ''"></o-textarea>
                </o-form-group>
              </b-col>
            </b-row>
          </b-modal>

          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.addresses')" v-if="fieldVisibility.tabAddresses">
          <div class="d-flex">
            <b-btn @click="addAddress">{{$t('sandoz.add_address')}}</b-btn>

            <b-input-group-append class="ml-1" :disabled="!item.customer_external_id">
              <b-dropdown variant="primary" type="button" split :text="$t('sandoz.add_sub_addresses')" @click.prevent="addSubAddresses">
                <b-dropdown-item @click.prevent="$refs.subAddressListModal.show()">{{$t('sandoz.add_addresses_from_list')}}</b-dropdown-item>
              </b-dropdown>
            </b-input-group-append>

            <span class="ml-auto">{{$tc('sandoz.addresses_count', item.addresses.length, {count: item.addresses.length})}}</span>
          </div>

          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>{{$t('sandoz.hco')}}</th>
                  <th>{{$t('sandoz.address')}}</th>
                  <th>{{$t('sandoz.zip')}}</th>
                  <th>{{$t('sandoz.city')}}</th>
                  <th>{{$t('sandoz.customer_external_id')}}</th>
                  <th v-if="item.type == 'KAM_SD'">{{$t('sandoz.fte')}}</th>
                  <th v-if="item.type == 'KAM_APO' || item.type == 'BIOS_KAM_APO'">{{$t('sandoz.classification')}}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(address, addressIndex) in item.addresses" :key="addressIndex" :class="{'bg-light': address.address_type == 'master'}">
                  <td>
                    {{address.company_name}}
                    <o-inline-edit v-model="address.company_name" v-if="address.address_type == 'master'"/>
                  </td>
                  <td>
                    {{address.street}}
                    <o-inline-edit v-model="address.street" v-if="address.address_type == 'master'"/>
                  </td>
                  <td>
                    {{address.zip}}
                    <o-inline-edit v-model="address.zip" v-if="address.address_type == 'master'"/>
                  </td>
                  <td>
                    {{address.city}}
                    <o-inline-edit v-model="address.city" v-if="address.address_type == 'master'"/>
                  </td>
                  <td>{{address.customer_external_id}}</td>
                  <td v-if="item.type == 'KAM_SD'" class="text-nowrap">
                    <b-input v-model.number="address.fte" step="0.05" type="number" class="mw-very-small"/>
                  </td>
                  <td v-if="item.type == 'KAM_APO' || item.type == 'BIOS_KAM_APO'">
                    <o-value-select-control :items="customerSizes" v-model="address.customer_size"/>
                  </td>
                  <td class="text-right text-nowrap">
                      <div aria-label="edit controls" class="btn-group btn-group-sm" role="group" v-if="address.address_type != 'master'">
                          <o-delete v-on:execute-action="item.addresses.splice(addressIndex, 1)"
                                    text="Are you sure you want to remove this address?"></o-delete>
                      </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.items')" v-if="fieldVisibility.tabItems">

          <div class="d-flex">
            <b-btn @click="showAddIcePeakItemModal">{{$t('sandoz.add_icepeak_item')}}</b-btn>
            <b-btn @click="showAddCustomItemModal" class="ml-1" v-if="!sortalysContract">{{$t('sandoz.add_custom_item')}}</b-btn>

            <span class="ml-auto text-right">
              {{$t('sandoz.marketing_activities_total')}}: {{ item.marketing_activities | formatNumber}}
              <br>
              {{$t('sandoz.selected')}}: {{ priceTotal | formatNumber}}
              <div :class="{'text-danger': item.marketing_activities != priceTotal}">
                {{$t('sandoz.remaining_activities')}}: {{ (item.marketing_activities - priceTotal) | formatNumber}}
              </div>
            </span>
          </div>

          <b-modal ref="kamItemModal" :title="kamItemModalTitle" @ok="addKamItem(kamItem)" size="lg">
            <o-value-select :label="$t('sandoz.product')" ref="productSelector"
                v-if="item && item.language && kamItem.mode == 'icepeak'"
                text-field="name_lang" :url="`/api/sandoz/products?sortBy=name&filter%5Bstatus%5D=active&filter%5Bcontract_type%5D=${item.type}&filter%5Blanguage%5D=` + item.language.toLowerCase()+`&filter%5Byear%5D=` + item.contract_year+`&filter%5Binvoicing_allowed%5D=1` " v-model="kamItem.product_id"
                value-field="id">
            </o-value-select>

            <b-row v-if="kamItem.mode == 'custom'">
              <b-col>
                <o-input :label="$t('sandoz.product_name_from_catalog')" v-model.number="kamItem.product_name"></o-input>
              </b-col>
              <b-col>
                <o-form-group :label="$t('sandoz.item_classification')">
                  <fa icon="info-circle" class="item-class-icon" v-b-modal.classificationInfo></fa>
                  <o-value-select-control ref="classificationSelector"
                                          url="/api/sandoz/custom_item_classifications" value-field="id" text-field="type_treatment"
                                          v-model="kamItem.classification_id"></o-value-select-control>
                </o-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col><o-input :label="$t('sandoz.quantity')" v-model.number="kamItem.quantity"></o-input></b-col>
              <b-col><o-input :label="$t('sandoz.total_price')" v-model.number="kamItem.price"></o-input></b-col>
            </b-row>

            <b-row :class="{'d-none': sortalysContract}">
              <b-col>
                <o-datepicker :label="$t('sandoz.valid_from')" :typeable="true" v-model="kamItem.valid_from"
                              :disabled-dates="disableValidFromDates(item.contract_year)">
                </o-datepicker>
              </b-col>
              <b-col>
                <o-datepicker :label="$t('sandoz.valid_to')" :typeable="true" v-model="kamItem.valid_to"
                              :disabled-dates="disableValidToDates(kamItem.valid_from)">
                </o-datepicker>
              </b-col>
            </b-row>

            <o-checkbox v-if="kamItem.mode == 'custom'" :label="$t('sandoz.disclosure')" v-model="kamItem.disclosure"/>

            <o-form-group :label="$tc('sandoz.addresses_count', selectedAddressCount, {count: selectedAddressCount})">
              <b-form-radio v-model="kamItem.address_connection" @input="kamItemQuantityUpdate" name="address_connection" value="only_headquarter">
                {{$t('sandoz.found_only_at_headquarter')}}
              </b-form-radio>
              <b-form-radio v-model="kamItem.address_connection" @input="kamItemQuantityUpdate" name="address_connection" value="all">
                {{$t('sandoz.found_at_all_addresses')}}
                <span class="text-danger" v-if="kamItem.address_connection === 'all' && item.addresses && item.addresses.filter(a => a.address_type == 'delivery').length <= 0">
                  ({{ $tc('sandoz.addresses_count', 0, {count: 0}) }})
                </span>
              </b-form-radio>
              <b-form-radio v-model="kamItem.address_connection" @input="kamItemQuantityUpdate" name="address_connection" value="individual">
                {{$t('sandoz.found_at_selected_addresses')}}

                <template v-if="kamItem.address_connection == 'individual'">
                  (
                    <a href="#" @click.prevent="selectAllAddresses(kamItem)">{{$t('sandoz.select_all')}}</a>
                    |
                    <a href="#" @click.prevent="deselectAllAddresses(kamItem)">{{$t('sandoz.deselect_all')}}</a>
                  )
                </template>
              </b-form-radio>

              <div v-if="kamItem.address_connection == 'individual'">
                <b-form-checkbox
                  v-model="kamItem.selectedAddresses"
                  v-for="(address, addressIndex) in item.addresses"
                  :value="address.id"
                  :key="addressIndex"
                  name="item-addresses"
                >
                  {{address.company_name}},
                  {{address.street}},
                  {{address.zip}}
                  {{address.city}}
                </b-form-checkbox>
              </div>
            </o-form-group>

            <o-form-group :label="$t('sandoz.delivery')" v-if="kamItem.mode != 'custom'">
              <b-form-radio v-model="kamItem.delivery_mode" name="delivery_mode" value="everything_at_beginning">{{$t('sandoz.delivery_undefined')}}</b-form-radio>
              <b-form-radio v-model="kamItem.delivery_mode" name="delivery_mode" value="individual">{{$t('sandoz.individual_delivery_dates')}}</b-form-radio>

              <div v-if="kamItem.delivery_mode == 'individual'">
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th>{{$t('sandoz.date')}}</th>
                      <th>{{$t('sandoz.address')}}</th>
                      <th>{{$t('sandoz.quantity')}}</th>
                      <th>{{$t('sandoz.exists')}}</th>
                      <th class="text-right text-nowrap">
                        <b-dropdown split @click.prevent="kamItem.deliveries.push({delivery_date: null, address_id: null, quantity: null, already_exists: false})" variant="secondary" size="sm">
                          <template #button-content>
                            <fa icon="plus"/>
                          </template>

                          <b-dropdown-item href="#" @click.prevent="$refs.addMultipleModal.show()">{{$t('sandoz.add_multiple')}}</b-dropdown-item>
                        </b-dropdown>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(delivery, deliveryIndex) in kamItem.deliveries" :key="deliveryIndex">
                      <td>
                        <o-datepicker-control :typeable="true" v-model="delivery.delivery_date"></o-datepicker-control>
                      </td>
                      <td>
                        <o-value-select-control
                          text-field="company_name" :items="selectedAddressObjects" v-model="delivery.address_id"
                          value-field="id">
                        </o-value-select-control>
                      </td>
                      <td>
                        <o-input-control @input="kamItemQuantityUpdate" v-model.number="delivery.quantity"></o-input-control>
                      </td>
                      <td>
                        <o-checkbox-control v-model="delivery.already_exists"></o-checkbox-control>
                      </td>
                      <td class="text-right text-nowrap">
                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                          <b-btn @click.prevent="removeKamItemDelivery(deliveryIndex)" variant="secondary" size="sm">
                            <fa icon="times"/>
                          </b-btn>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <td></td>
                    <td></td>
                    <td colspan="3">
                      {{$t('sandoz.allocated_quantity')}}:
                      {{kamItem.deliveries.map(d => d.quantity).reduce((a,b)=>a+b, 0)}}
                      <div v-if="kamItem.quantity && kamItem.deliveries.map(d => d.quantity).reduce((a,b)=>a+b, 0) != kamItem.quantity" class="text-danger">
                        {{$t('sandoz.unallocated_quantity', {qty: kamItem.quantity - kamItem.deliveries.map(d => d.quantity).reduce((a,b)=>a+b, 0)})}}
                      </div>
                    </td>
                  </tfoot>
                </table>
              </div>
            </o-form-group>
          </b-modal>

          <b-modal ref="addMultipleModal" :title="$t('sandoz.add_multiple')" @ok="addMultipleDeliveries">
              {{$t('sandoz.add_multiple_explanation')}}
              <o-datepicker :label="$t('sandoz.delivery_date')" :typeable="true" class="mt-3" v-model="multipleAdd.delivery_date"></o-datepicker>
              <o-input @input="kamItemQuantityUpdate" :label="$t('sandoz.quantity')" v-model.number="multipleAdd.quantity"></o-input>
          </b-modal>

          <b-modal ref="subAddressListModal" :title="$t('sandoz.sub_address_list_modal')" scrollable>
            <p>{{$t('sandoz.sub_address_list_modal_text')}}</p>

            <textarea class="form-control" v-model="subAddressList.input" @keyup="updateExternalIDlist">

            </textarea>

            <div v-if="subAddressList.externalIDs.length > 0">
              <hr>
              <table class="w-100">
                <tr v-for="(externalID, index) in subAddressList.externalIDs" :key="index">
                  <td>
                    {{externalID.externalID}}
                  </td>
                  <td class="text-right">
                    <span class="badge badge-success" v-if="externalID.feedback == 'added'">{{$t('sandoz.address_added')}}</span>
                    <span class="badge badge-secondary" v-if="externalID.feedback == 'exists'">{{$t('sandoz.address_already_exists')}}</span>
                    <span class="badge badge-warning" v-if="externalID.feedback == 'not_found'">{{$t('sandoz.address_not_found')}}</span>
                  </td>
                </tr>
              </table>
            </div>

            <template #modal-footer="{ cancel }">
              <b-button variant="secondary" @click="cancel()" class="ml-auto">
                {{$t('core.cancel')}}
              </b-button>
              <b-button variant="primary" @click="addAddressListImp">
                {{$t('sandoz.add_addresses')}}
              </b-button>
            </template>
          </b-modal>

          <b-modal ref="subAddressModal" :title="$t('sandoz.sub_address_modal')">
            <p>{{$t('sandoz.sub_address_modal_text')}}</p>

            <template #modal-footer="{ cancel }">
              <b-button variant="secondary" @click="cancel()" class="ml-auto">
                {{$t('core.cancel')}}
              </b-button>
              <b-button variant="primary" @click="addSubAddressesImpl">
                {{$t('sandoz.append_addresses')}}
              </b-button>
              <b-button variant="primary" @click="clearAndAddSubAddressesImpl">
                {{$t('sandoz.clear_and_append_addresses')}}
              </b-button>
            </template>
          </b-modal>

          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>{{$t('sandoz.item_name')}}</th>
                  <th>{{$t('sandoz.address')}}</th>
                  <th>{{$t('sandoz.classification')}}</th>
                  <th class="text-right">{{$t('sandoz.quantity')}}</th>
                  <th class="text-right">{{$t('sandoz.total_price')}}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(kamItem, kamItemIndex) in item.kam_items" :key="kamItemIndex">
                  <td>
                    <template>{{kamItem.product_name}}</template>
                    <span class="badge badge-warning" v-if="!kamItem.product_id">{{$t('sandoz.custom_item')}}</span>
                  </td>
                  <td>
                    <span v-if="kamItem.address_connection == 'only_headquarter' || checkHeadquarter(kamItem)">
                      {{$t('sandoz.found_only_at_headquarter')}}
                    </span>
                    <span v-else-if="kamItem.address_connection == 'all'">
                      {{$t('sandoz.found_at_all_addresses')}}
                    </span>
                    <span v-else>
                      {{kamItem.addresses.length}}
                    </span>
                  </td>
                  <td v-if="kamItem.product_id">{{kamItem.classification}}</td>
                  <td v-else>{{kamItem.custom_classification?kamItem.custom_classification.treatment:null}}</td>
                  <td class="text-right">{{kamItem.quantity}}</td>
                  <td class="text-right">{{kamItem.price | formatNumber}}</td>
                  <td class="text-right text-nowrap">
                      <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                          <b-btn @click.prevent="editItem(kamItem, kamItemIndex)" variant="secondary">
                              <fa icon="pencil-alt"/>
                          </b-btn>
                          <b-btn @click.prevent="item.kam_items.splice(kamItemIndex, 1)" variant="secondary">
                              <fa icon="times"/>
                          </b-btn>
                      </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.proof_of_evidence')" v-if="fieldVisibility.tabProofOfEvidence">

          <div v-if="item.kam_items.length == 0" class="alert alert-info">
            {{$t('sandoz.add_items_first')}}
          </div>
          <div v-else>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>{{$t('sandoz.item_name')}}</th>
                    <th>{{$t('sandoz.date_range')}}</th>
                    <th>{{$t('sandoz.sample_size')}}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(kamItem, kamItemIndex) in item.kam_items" :key="kamItemIndex">
                    <td>{{kamItem.product_name}}
                      <span class="badge badge-warning" v-if="!kamItem.product_id">{{$t('sandoz.custom_item')}}</span>
                    </td>
                    <td>
                      <template v-if="kamItem.valid_from || kamItem.valid_to">
                        {{kamItem.valid_from | formatDate}} - {{kamItem.valid_to | formatDate}}
                      </template>
                      <template v-else>
                        {{$t('sandoz.valid_during_contract_duration')}}
                      </template>
                    </td>
                    <td>
                      {{kamItem.proof_sample_size*100}}%

                      <template v-if="kamItem.proof_sample_size">
                        <span :class="{'text-danger': loadProofSampleSize(kamItem) <= 0}">
                          ({{$tc('sandoz.addresses_count', (loadProofSampleSize(kamItem)), {count: loadProofSampleSize(kamItem)})}})
                        </span>
                      </template>
                    </td>
                    <td class="text-right text-nowrap">
                      <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                        <b-btn variant="secondary" @click.prevent="editProof(kamItem, kamItemIndex)">
                          <fa icon="check-double"/>
                        </b-btn>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <b-modal ref="proofItemModal" :title="$t('sandoz.define_proof_requirements')" size="lg" @ok="updateProofItem(kamItem)">
            <o-input :label="$t('sandoz.product_name')" :readonly="true" v-model="kamItem.product_name"/>
            <hr>
            <o-input :label="$t('sandoz.comment')" v-model="kamItem.comment"/>
            <o-input-percentage @input="proofSampleSizeUpdated(kamItem)" :max="100" :label="$t('sandoz.proof_sample_size')" v-model="kamItem.proof_sample_size" :step="1"/>

            <o-form-group :label="$t('sandoz.addresses')">
              <template v-for="address in item.addresses">
                <div class="d-flex" :key="address.id" v-if="kamItem.selectedAddresses.includes(address.id) ||
                  (kamItem.selectedAddresses.length == 0 && kamItem.address_connection == 'all' && address.address_type == 'delivery') ||
                  (kamItem.selectedAddresses.length == 0 && kamItem.address_connection == 'only_headquarter' && address.address_type == 'master')"
                >
                  <div>{{address.company_name}}, {{address.street}}, {{address.zip}} {{address.city}}</div>
                  <div class="ml-auto">
                    <span>
                      <span v-if="kamItem.selectedProofAddresses.includes(address.id)" class="badge badge-success">{{$t('sandoz.proof_required')}}</span>
                      <span v-else class="badge badge-warning">{{$t('sandoz.no_proof_required')}}</span>
                    </span>
                  </div>
                </div>
              </template>
            </o-form-group>
          </b-modal>

          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.contract')" v-if="fieldVisibility.tabContract && checkKamWhs(item, fieldVisibility.tabContract)">
          <template v-if="item.type === 'KAM_SD_SORTALYS'">
            <o-button native-type="button" @click="pdfContract" class="btn btn-danger" target="_blank"
                      :loading="saving" :disabled="saving">
              {{$t('sandoz.download_pdf')}}
            </o-button>
          </template>
          <template v-else-if="item.type === 'KAM_WHS'">
                <b-btn @click="generateDocx('discount')" v-if="this.$route.params.id !== 'new'">{{$t('sandoz.generate_docx')}}</b-btn>
          </template>
          <template v-else-if="item.type === 'KAM_SD'">
            <b-btn @click="generateDocx('discount')" v-if="this.$route.params.id !== 'new'">{{$t('sandoz.generate_discount_docx')}}</b-btn>
            <b-btn @click="generateDocx('network')" v-if="this.$route.params.id !== 'new'">{{$t('sandoz.generate_network_docx')}}</b-btn>
          </template>
          <template v-else>
            <b-btn @click="generateDocx('discount')" v-if="this.$route.params.id !== 'new'">{{$t('sandoz.generate_docx')}}</b-btn>
          </template>
          <template-download-button v-if="this.$route.params.id !== 'new'" :contract-id="this.$route.params.id" class="ml-2"/>


          <b-row class="mt-4">
            <b-col xl="8" lg="12" md="12">
              <o-value-select :items="paymentSchemas" :label="$t('sandoz.payment_schema')" v-model="item.payment_schema"/>

              <template v-for="i in [1,2,3,4,5,6,7]">
                <o-form-group :label="$t('sandoz.contract_partner_' + i)" :key="i">
                  <b-container class="w-100 px-0">
                    <b-row>
                      <b-col class="pr-1">
                          <b-input-group :prepend="$t('sandoz.name')">
                            <b-form-input v-model="item['contract_partner_' + i]"></b-form-input>
                          </b-input-group>
                      </b-col>
                      <b-col class="pl-1">
                          <b-input-group :prepend="$t('sandoz.title')">
                            <b-form-input v-model="item['contract_partner_' + i + '_title']"></b-form-input>
                          </b-input-group>
                      </b-col>
                    </b-row>
                  </b-container>
                </o-form-group>
              </template>
            </b-col>
            <b-col xl="4" lg="12" md="12">
              <o-form-group>
                <b-form-checkbox v-model.lazy="item.vat" name="vat" value="x">
                  {{$t('sandoz.vat_obligation')}}
                </b-form-checkbox>
              </o-form-group>

              <o-input v-if="item.vat == 'x'" :errorField="'vat_number'" :label="$t('sandoz.vat_number')" v-model="item.vat_number"/>
              <o-input :errorField="'bank_name'" :label="$t('sandoz.bank_name')" v-model="item.bank_name"/>
              <o-input :errorField="'bank_address'" :label="$t('sandoz.bank_address')" v-model="item.bank_address"/>
              <o-input :errorField="'accountholder_name'" :label="$t('sandoz.accountholder_name')" v-model="item.accountholder_name"/>
              <o-input :errorField="'accountholder_address'" :label="$t('sandoz.accountholder_address')" v-model="item.accountholder_address"/>
              <o-input :errorField="'iban_no'" :label="$t('sandoz.iban_no')" v-model="item.iban_no"/>

            </b-col>
          </b-row>

          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.files')" v-if="fieldVisibility.tabFile && item.contract_year > 2023">
          <contract-file :item="item" :user="user"></contract-file>
          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
        </b-tab>
      </b-tabs>



      <address-search ref="addressSearch" :address-mode-checkbox="showAddressModeCheckbox" @address-selected="addressSelected"></address-search>

      <b-modal id="kamAdvertismentInfo" ok-only :title="$t('sandoz.marketing_split')">
        <p v-html="$t('sandoz.marketing_split_text')"/>
      </b-modal>

      <b-modal size="xl" id="classificationInfo" ok-only :title="$t('sandoz.general_guidance')">
        <div class="table-responsive">
          <table class="table">
            <thead>
            <tr>
              <th>{{$t('sandoz.type_of_services')}}</th>
              <th>{{$t('sandoz.description')}}</th>
              <th>{{$t('sandoz.acc_treatment')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Sales & Stock-in-trade data</td>
              <td>Payments to obtain data about sales and/or stock-in-trade on various level of detail (per SKU, per customer, per different frequency etc.) that are provided by customers (wholesaler, pharmacy chains...) are classified as not to be distinct from the purchase of goods. Therefore such payments are to be treated as a revenue reduction.</td>
              <td>GtN</td>
            </tr>
            <tr>
              <td>Stock level maintenance/availability of Sandoz products </td>
              <td>This category includes ensuring and maintaining required level of Sandoz products at customer’s premises. Such kind of service is not distinct as it is highly dependent or interrelated with regular sales. </td>
              <td>GtN</td>
            </tr>
            <tr>
              <td>Listing fees</td>
              <td>Listing fees are payments provided to pharmacy chains and other customers for enlisting Sandoz products into their trade portfolio. Such kind of payments is not a payment for a distinct service as it is highly interrelated with sales, as such Sandoz cannot benefit from the service on its own and will benefit together with regular sale.</td>
              <td>GtN</td>
            </tr>
            <tr>
              <td>Product display/visibility</td>
              <td>Product display/visibility includes payments for placement of Sandoz products into well visible (prime, hot zone) areas in pharmacies. Such service cannot be separated from the purchase of the Sandoz product, the service is not distinct, therefore the payment is to be considered a reduction in the transaction price.</td>
              <td>GtN</td>
            </tr>
            <tr>
              <td>Advertising activities at point-of-sale (POS) </td>
              <td>Activities such as renting of advertising space in shopping windows of pharmacies, placement of posters or leaflets inside pharmacies, advertising in customer’s magazines, brochures, leaflets, TV, radio and internet etc., targeted at the patients / final customers, are included in this category. Nature of the advertising activities could be promotion of special sales/commercial action/campaign or general advertising of Sandoz brands and products. </td>
              <td>TFC</td>
            </tr>
            <tr>
              <td>Advertising in customer’s own media</td>
              <td>This category includes activities where the customer is using their own media channels (e.g. internal newsletters for pharmacy groups, sales offers, etc.) to promote the Sandoz brand or specific products to their internal customers, i.e. not targeted at the patients / final customers. Such services cannot be obtained from other parties, also, the main beneficiary of such activities are rather the customer than Sandoz. Such services are therefore not considered to be distinct.</td>
              <td>GtN</td>
            </tr>
            <tr>
              <td>Administration fees for processing of activities</td>
              <td>Administration fees charged for organizing/processing of various commercial and promotional campaigns upon request of Sandoz.  Typically those payments are requested by wholesalers to compensate their effort (e.g. time of their employees and other costs) invested into activities such as processing a pass-through bonus to a final customer. Administration fees charged by a customer are perceived not to be distinct from the purchase of goods. Therefore such payments are treated as a revenue reduction.</td>
              <td>GtN</td>
            </tr>
            <tr>
              <td>Trainings of pharmacies’ staff (1/2)</td>
              <td>Costs related to training/education of pharmacy personnel either focused on Sandoz products (such as product indications, effects, dosing...) or general knowledge related to treatment (e.g. about specific diagnosis or appropriate using of antibiotics (ATB) in the form of face-to-face meetings, participation at seminars, e-learnings. Payments related to the activities may include compensation to pharmacies for the time that a pharmacy personnel cannot spend at their regular work duties (‘entrance fees’). Such payments are not for a distinct service provided by the customer. </td>
              <td>GtN</td>
            </tr>
            <tr>
              <td>Trainings of pharmacies’ staff (2/2)</td>
              <td>Cost of seminars (space renting, training materials, e-learnings applications and similar) paid to the customer can be considered to be payments for a distinct service, provided the fair value of the services can be established and the service is distinct. </td>
              <td>TFC</td>
            </tr>
            <tr>
              <td>Telemarketing</td>
              <td>This category includes payments for a call-center type of services, where typically wholesaler upon request of Sandoz performs phone calls to its customers (i.e. pharmacies or buying groups) with specific promotional offer and/or general information related to Sandoz products.
                <br><br>As the services provided are targeting internal customers, not the patient / final customer, the benefits obtained by Sandoz are only indirect, if any. Also, the service can only be obtained through the wholesaler, as the wholesaler’s internal customers cannot be addressed the same way through other channels. The service provided is therefore not distinct.
              </td>
              <td>GtN</td>
            </tr>
            <tr>
              <td>Proof of Evidence only</td>
              <td>Category for items designed to gather proof of evidence.
              </td>
              <td>GtN</td>
            </tr>
            </tbody>
          </table>
        </div>
      </b-modal>
    </o-card>
    <o-action-toolbar>
      <div class="d-flex w-100">
        <o-button type="button" variant="outline-primary" @click.prevent="back">{{$t('core.back')}}</o-button>
        <div class="ml-auto">
          <span class="text-danger mr-3" v-if="item && Math.sign(item.marketing_activities - priceTotal) === -1">{{ $t('sandoz.budget_exceeded') }}</span>
          <o-button type="button" variant="primary" v-if="(item && item.status == 'Draft')" :loading="saving" @click.prevent="contractCanApprovable()" :disabled="Math.sign(item.marketing_activities - priceTotal) === -1 || uniquenessCheckData.exists">{{$t('sandoz.upload_start_approval')}}</o-button>
          <o-button type="button" variant="primary" v-if="(item && item.status == 'Feedback')" :loading="saving" @click.prevent="contractCanApprovable(true)" :disabled="Math.sign(item.marketing_activities - priceTotal) === -1 || uniquenessCheckData.exists">{{$t('sandoz.continue_approval_process')}}</o-button>

          <o-button type="button" variant="primary" v-if="(item && (item.status == 'Draft'))" :loading="saving" @click.prevent="save" :disabled="uniquenessCheckData.exists">{{$t('sandoz.save_draft')}}</o-button>
          <o-button type="button" variant="primary" v-if="(item && (item.status == 'Feedback'))" :loading="saving" @click.prevent="save" :disabled="uniquenessCheckData.exists">{{$t('core.save')}}</o-button>
        </div>
      </div>
    </o-action-toolbar>

    <b-modal id="modal-previous-contract" ref="addPreviousContractModel" :title="$t('sandoz.select_previous_contract')"
             :ok-only="true" size="xl" :ok-title="$t('core.cancel')">
      <o-table url="/api/sandoz/contracts?include=master_address_single" title="" ref="previousContractList" :enable-new="false"
               :enable-delete="false" :enable-edit="false" :shadow="false" :only-filterable="true">
        <template slot="filter">
          <o-filter v-on:filter-updated="(filters) => $refs.previousContractList.setFilters(filters)">
            <o-filter-text :title="$t('sandoz.contract_no')" column="contract_no"></o-filter-text>
            <o-filter-text :title="$t('sandoz.customer_external_id')" column="customer_external_id"></o-filter-text>
            <o-filter-select :items="years" :title="$t('sandoz.contract_year')" column="contract_year"></o-filter-select>
          </o-filter>
        </template>
        <template slot="head">
          <o-table-header column="contract_no">{{$t('sandoz.contract_no')}}</o-table-header>
          <o-table-header column="customer_external_id">{{$t('sandoz.customer_external_id')}}</o-table-header>
          <o-table-header column="contract_year">{{$t('sandoz.contract_year')}}</o-table-header>
          <o-table-header :sortable="false">{{$t('sandoz.name')}}</o-table-header>
          <o-table-header :sortable="false">{{$t('sandoz.last_name')}}</o-table-header>
          <o-table-header :sortable="false">{{$t('sandoz.company_name')}}</o-table-header>
          <o-table-header :sortable="false">{{$t('sandoz.street')}}</o-table-header>
          <o-table-header :sortable="false">{{$t('sandoz.zip')}}</o-table-header>
          <o-table-header :sortable="false">{{$t('sandoz.city')}}</o-table-header>
        </template>
        <template slot="body" slot-scope="previousContractProps">
          <td>{{ previousContractProps.item.contract_no }}</td>
          <td>{{ previousContractProps.item.customer_external_id }}</td>
          <td>{{ previousContractProps.item.contract_year }}</td>
          <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
            previousContractProps.item.master_address_single.data.name : ''}}
          </td>
          <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
            previousContractProps.item.master_address_single.data.last_name : ''}}
          </td>
          <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
            previousContractProps.item.master_address_single.data.company_name : ''}}
          </td>
          <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
            previousContractProps.item.master_address_single.data.street : ''}}
          </td>
          <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
            previousContractProps.item.master_address_single.data.zip : ''}}
          </td>
          <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
            previousContractProps.item.master_address_single.data.city : ''}}
          </td>
        </template>
        <template slot="body-controls" slot-scope="previousContractProps">
          <td class="text-right">
            <div v-if="previousContractProps.item.id === item.id">
              <span class="badge badge-success">Current </span>
            </div>
            <div v-else-if="previousContractProps.item.id === item.previous_contract">
              <span class="badge badge-warning">Previous</span>
            </div>
            <div v-else class="btn-group btn-group-sm" role="group" aria-label="edit controls">
              <b-btn variant="primary" @click="addPreviousContract(previousContractProps.item)">
                <fa icon="arrow-right"/>
              </b-btn>
            </div>
          </td>
        </template>
      </o-table>
    </b-modal>

    <b-modal ref="uniqnessIssueModal" ok-only :title="$t('sandoz.contract_no_already_taken')">
      {{$t('sandoz.contract_no_already_taken_text')}}

      <hr>

      <div class="d-flex">
        <router-link :to="{ name: 'sandoz.kam.contract_detail', params: { id: uniquenessCheckData.id }}" target="_blank" class="btn btn-secondary">
          {{$t('sandoz.show_contract')}}
        </router-link>

        <b-button class="ml-auto" variant="secondary" @click.prevent="appendContractSuffix">{{$t('sandoz.append_contract_suffix')}}</b-button>
      </div>
    </b-modal>
    <b-modal id="modal-past-contract" ref="pastContractModel" :title="$t('sandoz.past_contract')">
      {{$t('sandoz.past_contract_warning')}}
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button variant="secondary" @click="cancel()">
          {{$t('core.cancel')}}
        </b-button>
        <b-button variant="primary" @click="approvalFeedback ? saveAndContinueApproval() : saveAndStartApproval()">
          {{ $t('sandoz.upload_start_approval') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-kam-warning" ref="kamWarningModal" :title="$t('sandoz.warning')">
      {{$t('sandoz.unusual_customer_number_for_kam')}}
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancelKamWarning()">
          {{$t('core.no')}}
        </b-button>
        <b-button variant="primary" @click="confirmKamWarning()">
          {{$t('core.yes')}}
        </b-button>
      </template>
    </b-modal>
  </form>
</template>

<script>
  import {mapGetters} from 'vuex'
  import axios from 'axios'
  import AddressSearch from '../partials/AddressSearch.vue'
  import moment from 'moment'
  import ContractFile from '../partials/ContractFiles.vue'
  import TemplateDownloadButton from '../partials/TemplateDownloadButton.vue'
  import contractYearMixin from '../../../mixins/contractYearMixin'

  export default {
    mixins: [contractYearMixin],
    components: {
      AddressSearch,
      ContractFile,
      TemplateDownloadButton
    },
    data: () => ({
      pendingAddressEvent: null,
      pendingAddressBulkResponse: null,
      activeTab: 0,
      contractTypes: [],
      item: null,
      loaded: false,
      watcherWorking: false,
      paymentSchemas: [],
      saving: false,
      url: '',
      languages: [],
      customerSizes: [],
      newObjectCounter: 0,
      subAddressProcessActive: false,
      watchers: [],
      multipleAdd: {
        delivery_date: null,
        quantity: null
      },
      uniquenessCheckData: {
        id: null,
        exists: false
      },
      kamItem: {
        id: null,
        mode: '',
        product_id: null,
        classification_id: null,
        product_name: null,
        quantity: null,
        price: null,
        valid_from: null,
        valid_to: null,
        selectedAddresses: [],
        selectedProofAddresses: [],
        disclosure: false,
        address_connection: 'only_headquarter',
        delivery_mode: 'everything_at_beginning',
        deliveries: [],
        custom_classification: []
      },
      fieldVisibility: {
        tabChecklist: false,
        tabAddresses: false,
        tabItems: false,
        tabProofOfEvidence: false,
        tabContract: false,
        tabFile: false,
        otherMarketing: false,
        advertisement: false,
        turnover: false,
        turnoverDevelopment: false,
        discount: false,
        marketingActivities: false,
        checkboxMultiYearContract: false,
        checkboxDeliveryRequired: false,
        checkboxAvailableMarketingItems: false,
        checkboxDisclosureRequirement: false,
        note: false,
        contractValue: false,
        contractDiscountValue: false,
        turnoverGx: false,
        turnoverOtc: false,
        turnoverDevelopmentGx: false,
        turnoverDevelopmentOtc: false,
        discountGx: false,
        discountGxVariable: false,
        discountOtc: false,
        marketingActivitiesGx: false,
        marketingActivitiesOtc: false,
        advertisementGx: false,
        otherMarketingGx: false,
        advertisementOtc: false,
        otherMarketingOtc: false
      },
      years: [],
      complianceSelect: null,
      complianceOnly: null,
      complianceReviewBoard:null,
      changeExternalID: false,
      approvalFeedback: false,
      isCommentError: false,
      showAddressModeCheckbox: false,
      activeTab: 0,
      subAddressList: {
        input: '',
        externalIDs: []
      },
      currentUser: null,
      marketing_activities_percentage: null,
      marketing_activities_percentage_otc: null,
      discount_percentage: null,
      discount_percentage_otc: null,
      plan_turnover_expectation_condition: null,
      plan_invest_condition: null,
      plan_discount_condition: null,
      plan_turnover_expectation_condition_otc: null,
      plan_invest_condition_otc: null,
      plan_discount_condition_otc: null,
      plan_turnover_outside_range:null,
      plan_turnover_expectation_outside_range:null,
      plan_invest_outside_range:null,
      plan_discount_outside_range:null,
      plan_turnover_outside_range_otc:null,
      plan_turnover_expectation_outside_range_otc:null,
      plan_invest_outside_range_otc:null,
      plan_discount_outside_range_otc:null,
      displayPlanDeviationSkipApproval: false,
      savingGXAccrual: false,
      savingOTCAccrual: false,
      originalKukos: null
    }),
    created() {
      this.contractTypes = [
        {
          value: 'KAM_APO',
          text: this.$i18n.t('sandoz.kam_apo'),
          fields: {
            tabChecklist: false,
            tabAddresses: true,
            tabItems: true,
            tabProofOfEvidence: true,
            tabContract: true,
            tabFile: true,
            otherMarketing: false,
            advertisement: false,
            turnover: false,
            turnoverDevelopment: false,
            discount: false,
            marketingActivities: false,
            checkboxMultiYearContract: true,
            checkboxDeliveryRequired: true,
            checkboxAvailableMarketingItems: true,
            checkboxDisclosureRequirement: true,
            note: false,
            contractValue: false,
            contractDiscountValue: false,
            turnoverGx: true,
            turnoverOtc: true,
            turnoverDevelopmentGx: true,
            turnoverDevelopmentOtc: true,
            discountGx: true,
            discountGxVariable: false,
            discountOtc: true,
            marketingActivitiesGx: true,
            marketingActivitiesOtc: true,
            advertisementGx: true,
            otherMarketingGx: true,
            advertisementOtc: true,
            otherMarketingOtc: true
          }
        },
        {
          value: 'KAM_SD',
          text: this.$i18n.t('sandoz.kam_sd'),
          fields: {
            tabChecklist: false,
            tabAddresses: true,
            tabItems: true,
            tabProofOfEvidence: true,
            tabContract: true,
            tabFile: true,
            otherMarketing: false,
            advertisement: false,
            turnover: false,
            turnoverDevelopment: false,
            discount: false,
            marketingActivities: false,
            checkboxMultiYearContract: true,
            checkboxDeliveryRequired: true,
            checkboxAvailableMarketingItems: true,
            checkboxDisclosureRequirement: true,
            note: false,
            contractValue: false,
            contractDiscountValue: false,
            turnoverGx: true,
            turnoverOtc: true,
            turnoverDevelopmentGx: true,
            turnoverDevelopmentOtc: true,
            discountGx: true,
            discountGxVariable: false,
            discountOtc: true,
            marketingActivitiesGx: true,
            marketingActivitiesOtc: true,
            advertisementGx: true,
            otherMarketingGx: true,
            advertisementOtc: true,
            otherMarketingOtc: true
          }
        },
        {
          value: 'KAM_WHS',
          text: this.$i18n.t('sandoz.kam_whs'),
          fields: {
            tabChecklist: false,
            tabAddresses: false,
            tabItems: true,
            tabProofOfEvidence: true,
            tabContract: true,
            tabFile: true,
            otherMarketing: false,
            advertisement: false,
            turnover: false,
            turnoverDevelopment: false,
            discount: false,
            marketingActivities: false,
            checkboxMultiYearContract: true,
            checkboxDeliveryRequired: true,
            checkboxAvailableMarketingItems: true,
            checkboxDisclosureRequirement: true,
            note: false,
            contractValue: false,
            contractDiscountValue: false,
            turnoverGx: true,
            turnoverOtc: true,
            turnoverDevelopmentGx: true,
            turnoverDevelopmentOtc: true,
            discountGx: true,
            discountGxVariable: true,
            discountOtc: true,
            marketingActivitiesGx: true,
            marketingActivitiesOtc: true,
            advertisementGx: true,
            otherMarketingGx: true,
            advertisementOtc: true,
            otherMarketingOtc: true
          }
        },
        {
          value: 'KAM_DIVERSE_HOSP',
          text: this.$i18n.t('sandoz.kam_diverse_hosp'),
          fields: {
            tabChecklist: false,
            tabAddresses: false,
            tabItems: false,
            tabProofOfEvidence: false,
            tabContract: false,
            tabFile: true,
            otherMarketing: false,
            advertisement: false,
            turnover: false,
            turnoverDevelopment: false,
            discount: false,
            marketingActivities: false,
            checkboxMultiYearContract: true,
            checkboxDeliveryRequired: false,
            checkboxAvailableMarketingItems: false,
            checkboxDisclosureRequirement: false,
            note: true,
            contractValue: false,
            contractDiscountValue: true,
            turnoverGx: false,
            turnoverOtc: false,
            turnoverDevelopmentGx: false,
            turnoverDevelopmentOtc: false,
            discountGx: false,
            discountGxVariable: false,
            discountOtc: false,
            marketingActivitiesGx: false,
            marketingActivitiesOtc: false,
            advertisementGx: false,
            otherMarketingGx: false,
            advertisementOtc: false,
            otherMarketingOtc: false
          }
        },
        {
          value: 'KAM_DIVERSE_INSUR',
          text: this.$i18n.t('sandoz.kam_diverse_insur'),
          fields: {
            tabChecklist: false,
            tabAddresses: false,
            tabItems: false,
            tabProofOfEvidence: false,
            tabContract: false,
            tabFile: true,
            otherMarketing: false,
            advertisement: false,
            turnover: false,
            turnoverDevelopment: false,
            discount: false,
            marketingActivities: false,
            checkboxMultiYearContract: true,
            checkboxDeliveryRequired: false,
            checkboxAvailableMarketingItems: false,
            checkboxDisclosureRequirement: false,
            note: true,
            contractValue: true,
            contractDiscountValue: false,
            turnoverGx: false,
            turnoverOtc: false,
            turnoverDevelopmentGx: false,
            turnoverDevelopmentOtc: false,
            discountGx: false,
            discountGxVariable: false,
            discountOtc: false,
            marketingActivitiesGx: false,
            marketingActivitiesOtc: false,
            advertisementGx: false,
            otherMarketingGx: false,
            advertisementOtc: false,
            otherMarketingOtc: false
          }
        },
        {
          value: 'KAM_SD_SORTALYS',
          text: this.$i18n.t('sandoz.kam_sd_sortlays'),
          fields: {
            tabChecklist: false,
            tabAddresses: true,
            tabItems: true,
            tabProofOfEvidence: false,
            tabContract: true,
            tabFile: true,
            otherMarketing: false,
            advertisement: false,
            turnover: false,
            turnoverDevelopment: false,
            discount: false,
            marketingActivities: true,
            checkboxMultiYearContract: false,
            checkboxDeliveryRequired: false,
            checkboxAvailableMarketingItems: false,
            checkboxDisclosureRequirement: false,
            note: false,
            contractValue: false,
            contractDiscountValue: false,
            turnoverGx: false,
            turnoverOtc: false,
            turnoverDevelopmentGx: false,
            turnoverDevelopmentOtc: false,
            discountGx: false,
            discountGxVariable: false,
            discountOtc: false,
            marketingActivitiesGx: false,
            marketingActivitiesOtc: false,
            advertisementGx: false,
            otherMarketingGx: false,
            advertisementOtc: false,
            otherMarketingOtc: false
          }
        },
        {
          value: 'BIOS_KAM_APO',
          text: this.$i18n.t('sandoz.bios_kam_apo'),
          fields: {
            tabChecklist: false,
            tabAddresses: true,
            tabItems: true,
            tabProofOfEvidence: true,
            tabContract: true,
            tabFile: true,
            otherMarketing: false,
            advertisement: false,
            turnover: false,
            turnoverDevelopment: false,
            discount: false,
            marketingActivities: false,
            checkboxMultiYearContract: true,
            checkboxDeliveryRequired: true,
            checkboxAvailableMarketingItems: true,
            checkboxDisclosureRequirement: true,
            note: false,
            contractValue: false,
            contractDiscountValue: false,
            turnoverGx: true,
            turnoverOtc: true,
            turnoverDevelopmentGx: true,
            turnoverDevelopmentOtc: true,
            discountGx: true,
            discountGxVariable: false,
            discountOtc: true,
            marketingActivitiesGx: true,
            marketingActivitiesOtc: true,
            advertisementGx: true,
            otherMarketingGx: true,
            advertisementOtc: true,
            otherMarketingOtc: true
          }
        },
        {
          value: 'BIOS_KAM_WHS',
          text: this.$i18n.t('sandoz.bios_kam_whs'),
          fields: {
            tabChecklist: false,
            tabAddresses: false,
            tabItems: true,
            tabProofOfEvidence: true,
            tabContract: true,
            tabFile: true,
            otherMarketing: false,
            advertisement: false,
            turnover: false,
            turnoverDevelopment: false,
            discount: false,
            marketingActivities: false,
            checkboxMultiYearContract: true,
            checkboxDeliveryRequired: true,
            checkboxAvailableMarketingItems: true,
            checkboxDisclosureRequirement: true,
            note: false,
            contractValue: false,
            contractDiscountValue: false,
            turnoverGx: true,
            turnoverOtc: true,
            turnoverDevelopmentGx: true,
            turnoverDevelopmentOtc: true,
            discountGx: true,
            discountGxVariable: true,
            discountOtc: true,
            marketingActivitiesGx: true,
            marketingActivitiesOtc: true,
            advertisementGx: true,
            otherMarketingGx: true,
            advertisementOtc: true,
            otherMarketingOtc: true
          }
        }
      ]

      this.paymentSchemas = [
        {value: 'quarter', text: this.$i18n.t('sandoz.quarter')},
        {value: 'semester', text: this.$i18n.t('sandoz.semester')},
        {value: 'yearly', text: this.$i18n.t('sandoz.yearly')}
      ]

      this.languages = [
        {value: 'DE', text: 'DE'},
        {value: 'FR', text: 'FR'},
        {value: 'IT', text: 'IT'}
      ]

      this.customerSizes = [
        {value: '', text: ''},
        {value: 'Klein', text: this.$i18n.t('sandoz.small')},
        {value: 'Mittel', text: this.$i18n.t('sandoz.medium')},
        {value: 'Gross', text: this.$i18n.t('sandoz.big')},
        {value: 'Sehr gross', text: this.$i18n.t('sandoz.very_big')}
      ]

      this.updateContractYears()
    },
    mounted() {
      this.loadData()
    },
    computed: {
      ...mapGetters({
        user: 'auth/user'
      }),
      itemAddresses() {
        return this.item.addresses
      },
      kamItemModalTitle() {
        if (this.kamItem.id) {
          return this.kamItem.mode == 'icepeak' ? this.$t('sandoz.edit_icepeak_item') : this.$t('sandoz.edit_custom_item')
        }
        return this.kamItem.mode == 'icepeak' ? this.$t('sandoz.add_icepeak_item') : this.$t('sandoz.add_custom_item')
      },
      compCheckDeviation() {
        return this.$t('sandoz.check_compliance_deviation')
      },
      compCheckModalTitle() {
        return this.$t('sandoz.check_compliance_title')
      },
      compCheckModalIntro() {
        return this.$t('sandoz.check_compliance_intro')
      },
      compCheckPerformTitle() {
        return this.$t('sandoz.compliance_check_perform_title')
      },
      compDisableButtonCheck() {
        if(this.complianceReviewBoard === true && this.item.compilance_check_file === null) {
          return true
        }

        if(this.complianceOnly === true && this.complianceSelect === null) {
          return true
        }

        if(this.complianceOnly === true && this.complianceSelect === "false" && (this.item.compilance_check_note == null ||  this.item.compilance_check_note === "")) {
          return true
        }

        return false
      },
      selectedAddressObjects() {
        return this.item.addresses.filter(a => {
          return !this.kamItem.selectedAddresses || this.kamItem.selectedAddresses.includes(a.id) ||
            (this.kamItem.address_connection == 'all' && a.address_type == 'delivery') ||
            (this.kamItem.address_connection == 'only_headquarter' && a.address_type == 'master')
        })
      },
      selectedAddressCount() {
        // individual selection, count the ticked addresses
        if (this.kamItem.address_connection == 'individual') {
          return this.kamItem.selectedAddresses.length
        }
        // nothing selected, 0..
        if (this.item.addresses.length == 0) {
          return 0
        }

        if(this.kamItem.address_connection == 'only_headquarter') {
          return this.item.addresses.filter(a => a.address_type == 'master').length
        }

        // multiple addresses, exclude the master address
        return this.item.addresses.filter(a => a.address_type == 'delivery').length
      },
      priceTotal() {
        return this.item.kam_items.map(i => i.price).reduce((a,b) => Number(a)+Number(b), 0)
      },
      readonly () {
        return this.item && this.item.status != 'Draft' && this.item.status != 'Feedback'
      },
      sortalysContract() {
        return this.item.type === 'KAM_SD_SORTALYS';
      },
      biosContract () {
        return this.item.type === 'BIOS_KAM_APO' || this.item.type === 'BIOS_KAM_WHS'
      }
    },
    methods: {
      openKuko(kukoID) {
        if(kukoID !== '') {
          this.$router.push({ name:'sandoz.kuko.detail', params: {id:kukoID}})
        }
      },
      loadKukoDiscount() {
        if(this.item.type && this.item.contract_year && this.item.customer_external_id && (this.item.status === 'Draft' || this.item.status === 'Feedback')) {
          if (this.item.type !== 'KAM_APO') {
            this.$set(this.item, 'kukos', [])
            return
          }

          const self = this

          // Initialize originalKukos on first load
          if (!self.originalKukos) {
            self.originalKukos = (self.item.kukos || [])
              .filter(k => k && k.status !== 'Cancelled')
              .map(k => ({ id: k.id, status: k.status, discount_lower_100: k.discount_lower_100 }))
          }

          const existingKukos = (self.originalKukos || [])
            .filter(k => k && k.status !== 'Cancelled')
            .map(k => ({ id: k.id, status: k.status, discount_lower_100: k.discount_lower_100 }))
          self.$set(self.item, 'kukos', existingKukos)

          const updateKukoFields = () => {
            const sum = self.item.kukos.reduce((total, kuko) => total + (parseInt(kuko.discount_lower_100) || 0), 0)
            if (self.item.kukos.length > 0) {
              self.$set(self.item, 'kuko_link', self.item.kukos[0].id)
              self.$set(self.item, 'kuko_id', self.item.kukos[0].id)
              self.item.kuko_status = self.item.kukos[0].status
            } else {
              self.$set(self.item, 'kuko_link', null)
              self.$set(self.item, 'kuko_id', null)
              self.item.kuko_status = null
            }
          }

          // Fetch fresh data for each KUKO currently in self.item.kukos (e.g. from original load)
          const pivotPromises = (self.item.kukos || []).map(k =>
            axios.get(`/api/kukos/${k.id}`).then((response) => {
              const kukoData = response.data.data ? response.data.data : response.data
              if (kukoData) {
                const existing = self.item.kukos.find(kk => kk.id === kukoData.id)
                if (existing) {
                  existing.status = kukoData.status
                  existing.discount_lower_100 = kukoData.discount_lower_100
                }
              }
            }).catch(() => {})
          )

          Promise.all([...pivotPromises]).then(() => {
            updateKukoFields()
          }).catch((err) => {
            console.error("Error loading KUKO discounts:", err)
          })
        }
      },
      updateExternalIDlist() {
        this.subAddressList.externalIDs = this.subAddressList.input.split(/[ ,;\n\r]+/).filter(i => i.trim() !== '').map(i => {return {externalID: i, feedback: ''}})
      },
      processBulkAddressSelection(responseData) {
        var self = this
        responseData.forEach(address => {
          let currentRecord = self.subAddressList.externalIDs.findIndex(es => es.externalID == address.external_id)

          // check if address already exitss
          if (self.item.addresses.filter(a => a.customer_external_id == address.external_id).length > 0) {
            if (currentRecord !== -1) self.subAddressList.externalIDs[currentRecord].feedback = 'exists'
          }
          else {
            let addressCount = self.item.addresses.length
            var addressObject = {
                id: 'NEW_TEMP_ID_' + (++self.newObjectCounter),
                del_address: ++addressCount,
                address_type: 'delivery',
                company_name: address.parent.full_name,
                street: address.parent.street,
                zip: address.parent.zip_code,
                city: address.parent.city,
                customer_external_id: address.external_id,
                customer_external_id_hcp: address.external_id,
                customer_size: address.extension ? address.extension.pharmacy_classification : ''
              }

            self.item.addresses.push(addressObject)

            if (currentRecord !== -1) self.subAddressList.externalIDs[currentRecord].feedback = 'added'
          }
        })

        // mark all records we didn't get from our server as "not found"
        self.subAddressList.externalIDs.filter(a => a.feedback == '').forEach(e => e.feedback = 'not_found')
      },
      addAddressListImp() {
        var self = this
        var list = self.subAddressList.externalIDs.map(e => e.externalID)

        axios.post(`/api/sandoz/kam/contracts/get-addresses`, {externalIDs: list, exact_contract_type: self.item.type}).then(response => {
          let hasUnusual = false;
          if (self.item.type !== 'KAM_WHS') {
             for (let i = 0; i < response.data.length; i++) {
                if (response.data[i].external_id && !response.data[i].external_id.startsWith('CH_PBG')) {
                    hasUnusual = true;
                    break;
                }
             }
          }

          if (hasUnusual) {
             self.pendingAddressBulkResponse = response.data;
             self.$refs.kamWarningModal.show();
          } else {
             self.processBulkAddressSelection(response.data);
          }
        })
      },
      setFieldVisibility() {
        if (!this.item && !this.item.type) {
          return
        }

        if(this.item.type) {
          this.fieldVisibility = this.contractTypes.find(c => c.value == this.item.type).fields
        }
      },
      kamItemQuantityUpdate() {
        if (this.kamItem.address_connection == 'all') {
          this.selectAddressesExceptHC()
        } else if(this.kamItem.address_connection == 'only_headquarter') {
          this.selectHCAddresses()
        }
      },
      selectAllAddresses(kamItem) {
        this.kamItem.selectedAddresses = this.item.addresses.map(a => a.id)
      },
      selectAddressesExceptHC(kamItem) {
        this.kamItem.selectedAddresses = this.item.addresses.filter(a => a.address_type == 'delivery').map(a => a.id)
      },
      selectHCAddresses(kamItem) {
        this.kamItem.selectedAddresses = this.item.addresses.filter(a => a.address_type == 'master').map(a => a.id)
      },
      deselectAllAddresses(kamItem) {
        this.kamItem.selectedAddresses = []
      },
      addMultipleDeliveries() {
        this.selectedAddressObjects.forEach(a => {
          this.kamItem.deliveries.push({delivery_date: this.multipleAdd.delivery_date, address_id: a.id, quantity: this.multipleAdd.quantity, already_exists: false})
        })

        this.multipleAdd.quantity = null
        this.multipleAdd.delivery_date = null
      },
      removeKamItemDelivery(kamItem, deliveryIndex) {
        this.kamItem.deliveries.splice(deliveryIndex, 1)
        this.kamItemQuantityUpdate()
      },
      setWithoutWatcher(propertyName, value) {
        if (this.watcherWorking || !this.loaded) {
          return
        }
        this.watcherWorking = true
        this.item[propertyName] = value
        this.$nextTick(() => {
          this.watcherWorking = false
        })
      },
      generateDocx(type) {
        this.$root.$loading.start()
        axios.get(`/api/sandoz/kam/contracts/${this.$route.params.id}/${type}/docx`,
            { responseType: 'arraybuffer' })
          .then((response) => {
            require('downloadjs')(
                response.data,
                this.item.contract_no + '.docx',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            )
            this.$root.$loading.finish()
          }).catch((error) => {
            this.$root.$loading.finish()
            console.log(error)
          })
      },
      disableWatchers() {
        this.watchers.forEach(e => {
          e()
        })
      },
      enableWatchers() {
        this.watchers.push(this.$watch('item.discount_percentage', (newVal) => {
          this.setWithoutWatcher('discount', (this.item.turnover_expectation || 0) * (newVal || 0))
          this.sumGxOtc()
        }))
        this.watchers.push(this.$watch('item.discount_gx_percentage', (newVal) => {
          this.setWithoutWatcher('discount_gx', this.roundToWhole(this.item.turnover_gx_expectation * newVal))
          this.sumGxOtc()
        }))
        this.watchers.push(this.$watch('item.discount_gx_variable_percentage', (newVal) => {
          this.setWithoutWatcher('discount_gx_variable', this.item.turnover_gx_expectation * newVal)
          this.sumGxOtc()
        }))
        this.watchers.push(this.$watch('item.discount_otc_percentage', (newVal) => {
          this.setWithoutWatcher('discount_otc', this.roundToWhole(this.item.turnover_otc_expectation * newVal))
          this.sumGxOtc()
        }))

        this.watchers.push(this.$watch('item.turnover_expectation', (newVal) => {
          this.setWithoutWatcher('discount', newVal * (this.item.discount_percentage || 0))
          this.$nextTick(() => {
            this.setWithoutWatcher('marketing_activities_percentage', this.item.marketing_activities / newVal)
          })
          this.sumGxOtc()
        }))
        this.watchers.push(this.$watch('item.turnover_gx_expectation', (newVal) => {
          this.setWithoutWatcher('discount_gx', this.roundToWhole(newVal * this.item.discount_gx_percentage))
          this.$nextTick(() => {
            this.setWithoutWatcher('discount_gx_variable', newVal * this.item.discount_gx_variable_percentage)
            this.setWithoutWatcher('marketing_activities_gx_percentage', this.item.marketing_activities_gx / newVal)
          })
          this.sumGxOtc()
        }))
        this.watchers.push(this.$watch('item.turnover_otc_expectation', (newVal) => {
          this.setWithoutWatcher('discount_otc', this.roundToWhole(newVal * this.item.discount_otc_percentage))
          this.$nextTick(() => {
            this.setWithoutWatcher('marketing_activities_otc_percentage', this.item.marketing_activities_otc / newVal)
          })
          this.sumGxOtc()
        }))
        this.watchers.push(this.$watch('item.discount', (newVal) => {
          this.sumGxOtc()
        }))
        this.watchers.push(this.$watch('item.marketing_activities', (newVal) => {
          this.setWithoutWatcher('marketing_activities_percentage', newVal / this.item.turnover_expectation)
          this.sumGxOtc()
        }))
        this.watchers.push(this.$watch('item.marketing_activities_gx', (newVal) => {
          this.setWithoutWatcher('marketing_activities_gx_percentage', newVal / this.item.turnover_gx_expectation)
          this.sumGxOtc()
        }))
        this.watchers.push(this.$watch('item.marketing_activities_otc', (newVal) => {
          this.setWithoutWatcher('marketing_activities_otc_percentage', newVal / this.item.turnover_otc_expectation)
          this.sumGxOtc()
        }))

        this.watchers.push(this.$watch('item.type', (newVal) => {
          this.handleTypeChange(newVal)
          this.setContractNo()
          this.setPreviousContract()
          this.setFieldVisibility()
          this.setTurnoverInvest()
          this.loadplanData()
          this.$set(this.item, 'kuko_link', null)
          this.originalKukos = null
          this.loadKukoDiscount()
        }))
        this.watchers.push(this.$watch('item.customer_external_id', (newVal) => {
          this.changeExternalID = true
          this.setContractNo()
          this.setPreviousContract()
          this.$set(this.item, 'kuko_link', null)
          this.originalKukos = null
          this.loadKukoDiscount()
        }))
        this.watchers.push(this.$watch('item.contract_no_suffix', (newVal) => {
          this.setContractNo()
        }))
        this.watchers.push(this.$watch('item.contract_year', (newVal) => {
          this.setContractNo()
          this.setPreviousContract()
          this.setContractDates(newVal)
          this.loadplanData()
          this.$set(this.item, 'kuko_link', null)
          this.originalKukos = null
          this.loadKukoDiscount()
        }))
        this.watchers.push(this.$watch('item.contract_no', (newVal, oldVal) => {
          this.checkUniquenessOfContractNo()
        }))

        this.watchers.push(this.$watch('item.turnover_otc', (newVal, oldVal) => {
          this.sumGxOtc()
        }))
        this.watchers.push(this.$watch('item.turnover_gx', (newVal, oldVal) => {
          this.sumGxOtc()
        }))

        this.watchers.push(this.$watch('item.other_marketing_gx', (newVal, oldVal) => {
          this.sumGxOtc()
        }))
        this.watchers.push(this.$watch('item.other_marketing_otc', (newVal, oldVal) => {
          this.sumGxOtc()
        }))
        this.watchers.push(this.$watch('item.advertisement_gx', (newVal, oldVal) => {
          this.sumGxOtc()
        }))
        this.watchers.push(this.$watch('item.advertisement_otc', (newVal, oldVal) => {
          this.sumGxOtc()
        }))
        this.watchers.push(this.$watch('item.new_customer', (newVal) => {
          if(newVal === null) {
            this.setPreviousContract(true)
            this.item.no_previous_contract  = false
          } else {
            this.item.no_previous_contract  = true
          }
        }))

        this.watchers.push(this.$watch('item.contract_start', (newVal, oldVal) => {
          if(this.item && (this.item.status == 'Draft' || this.item.status == 'Feedback')) {
            this.loadplanData()
          }
        }))
        this.watchers.push(this.$watch('item.contract_expiration', (newVal, oldVal) => {
          if(this.item && (this.item.status == 'Draft' || this.item.status == 'Feedback')) {
            this.loadplanData()
          }
        }))

        this.watchers.push(this.$watch('item.plan_deviation_skip_approval', (newVal) => {
          this.sumGxOtc()
        }))

        this.watchers.push(this.$watch('currentUser', (newVal) => {
          this.sumGxOtc()
        }))

        this.watchers.push(this.$watch('item.is_discount_gx_accrual', (newVal) => {
            this.item.discount_gx_accrual = newVal ? this.roundToWhole(this.item.discount_gx) : null
        }))
        this.watchers.push(this.$watch('item.is_discount_otc_accrual', (newVal) => {
          this.item.discount_otc_accrual = newVal ? this.roundToWhole(this.item.discount_otc) : null
        }))
        this.watchers.push(this.$watch('kamItem.address_connection', (newVal) => {
          if(newVal === 'all') {
            this.selectAddressesExceptHC()
          } else if(newVal === 'only_headquarter') {
            this.selectHCAddresses()
          }
        }))
      },
      sumGxOtc() {
        this.$nextTick(() => {
          this.item.turnover = this.item.turnover_otc + this.item.turnover_gx
          this.item.turnover_expectation = new Number(this.item.turnover_gx_expectation) + new Number(this.item.turnover_otc_expectation)
          this.item.marketing_activities = this.item.marketing_activities_gx + this.item.marketing_activities_otc
          this.item.discount = Number(this.item.discount_gx || 0) + Number(this.item.discount_gx_variable || 0) + Number(this.item.discount_otc || 0)
          this.item.other_marketing = this.item.other_marketing_gx + this.item.other_marketing_otc
          this.item.advertisement = this.item.advertisement_gx + this.item.advertisement_otc

          this.$nextTick(() =>{
            this.setApprovers()
          })
        })
      },
      checkUniquenessOfContractNo() {
        axios.post(`/api/sandoz/kam/contracts/uniqueness-check`,
          {
            id: this.item.id,
            contract_no: this.item.contract_no,
            type: this.item.type,
            contract_year: this.item.contract_year,
            customer_external_id: this.item.customer_external_id
          }).then((response) => {
          this.uniquenessCheckData = response.data
          if (this.uniquenessCheckData.exists) {
            this.$refs.uniqnessIssueModal.show()
          }
        })
      },
      appendContractSuffix() {
        this.item.contract_no_suffix = this.uniquenessCheckData.next_suffix
        this.$refs.uniqnessIssueModal.hide()
      },
      proofSampleSizeUpdated(kamItem) {
        let sampleSize = kamItem.proof_sample_size

        let allAddresses = []
        if (kamItem.address_connection === 'only_headquarter'){
          allAddresses = this.item.addresses.length == 0 ? [] : this.item.addresses.filter(a => a.address_type == 'master').map(a => a.id)
        } else if(kamItem.address_connection === 'all') {
          allAddresses = this.item.addresses.length == 0 ? [] : this.item.addresses.filter(a => a.address_type == 'delivery').map(a => a.id)
        } else {
          allAddresses = kamItem.selectedAddresses
        }
        let addressSet = allAddresses
        let selectedAddressCount = addressSet.length

        let lotSize = Math.ceil(selectedAddressCount*sampleSize)

        // no need to change our sample set if nothing has changed
        if (lotSize == kamItem.selectedProofAddresses.length) {
          return
        }
        kamItem.selectedProofAddresses = [...addressSet].sort(() => 0.5 - Math.random()).slice(0, lotSize)
      },
      loadProofSampleSize(kamItem) {
        var self = this
        let sampleSize = kamItem.proof_sample_size

        let allAddresses = []
        if (kamItem.address_connection === 'only_headquarter'){
          allAddresses = this.item.addresses.length == 0 ? [] : this.item.addresses.filter(a => a.address_type == 'master').map(a => a.id)
        } else if(kamItem.address_connection === 'all') {
          allAddresses = this.item.addresses.length == 0 ? [] : this.item.addresses.filter(a => a.address_type == 'delivery').map(a => a.id)
        } else {
          allAddresses = kamItem.addresses
        }
        let addressSet = allAddresses
        let selectedAddressCount = addressSet.length

        let lotSize = Math.ceil(selectedAddressCount*sampleSize)

        kamItem.selectedProofAddresses = [...addressSet].sort(() => 0.5 - Math.random()).slice(0, lotSize)
        return kamItem.selectedProofAddresses.length
      },
      updateProofItem(kamItem) {
        let activeKamItem = this.item.kam_items.find(k => k.id == this.kamItem.id)

        activeKamItem.proof_sample_size = kamItem.proof_sample_size
        activeKamItem.comment = kamItem.comment

        activeKamItem.proofs = this.kamItem.selectedProofAddresses.map(a => ({
            address_id: a
          }))

        if(activeKamItem.proof_sample_size * 100 > 0 && activeKamItem.proofs.length <= 0) {
          this.$notify({
            title: this.$i18n.t('core.save_error'),
            text: this.$i18n.t('sandoz.no_address_error'),
            type: 'error'
          })
        }
      },
      addKamItem(kamItem) {
        let activeKamItem = null
        if (this.kamItem.id) {
          activeKamItem = this.item.kam_items.find(k => k.id == this.kamItem.id)
          activeKamItem.address_connection = kamItem.address_connection
        }

        let productName = ''
        let classificationId = null
        let treatment = null
        let type = null
        if (this.kamItem.mode == 'icepeak') {
          productName = this.$refs.productSelector.$el.querySelector("select option:checked").innerText
          classificationId = null
        }
        else {
          productName = this.kamItem.product_name
          let options = this.$refs.classificationSelector.$el.options
          classificationId = options.selectedIndex !== -1 ? options[options.selectedIndex].value : null

          if(!classificationId) {
            this.$notify({
              title: this.$i18n.t('core.validation_error'),
              text: this.$i18n.t('core.validation_error_text', { message: this.$i18n.t('sandoz.item_classification_required') }),
              type: 'error'
            })
            return
          }

          const classificationName = options.selectedIndex !== -1 ? options[options.selectedIndex].textContent : null
          if(classificationName) {
              let arrayClassification = classificationName.split(' ')
              treatment = arrayClassification.pop().replace(/[{()}]/g, '')
              type = arrayClassification.join(' ')
          }
        }

        let data = {
          price: this.kamItem.price,
          quantity: this.kamItem.quantity,
          product_id: this.kamItem.product_id > 0 ? this.kamItem.product_id : null,
          classification_id: classificationId,
          valid_from: this.kamItem.valid_from,
          valid_to: this.kamItem.valid_to,
          product_name: productName,
          deliveries: this.kamItem.deliveries,
          disclosure: this.kamItem.mode == 'icepeak' ? false : this.kamItem.disclosure,
          custom_classification: {
            type: type,
            treatment: treatment
          }
        }

        // if we already have an id, we are editing, otherwise we are adding
        if (activeKamItem) {
          activeKamItem = Object.assign(activeKamItem, data)
          let processedAddressIds = []
          this.kamItem.selectedAddresses.forEach(selectedAddressId => {
            var existingAddress = activeKamItem.addresses.find(a => a.address_id == selectedAddressId)
            // address not found, add a new record
            if (!existingAddress) {
              activeKamItem.addresses.push({address_id: selectedAddressId})
            }
            processedAddressIds.push(selectedAddressId)
          })

          // loop through existing addresses to remove those which aren't found in selected addresses
          for (let index = activeKamItem.addresses.length - 1; index >= 0; index--) {
            // is current item in processed list, if not, remove it
            if (!processedAddressIds.includes(activeKamItem.addresses[index].address_id)) {
              activeKamItem.addresses.splice(index, 1)
            }
          }

          this.$forceUpdate()
        }
        else {
          data.address_connection = this.kamItem.address_connection
          data.addresses = this.kamItem.selectedAddresses.map(a => ({
            address_id: a
          }))
          data.id = 'NEW_TEMP_ID_' + (++this.newObjectCounter)
          data.proof_sample_size = 0
          this.item.kam_items.push(data)
        }

        this.$refs.kamItemModal.hide()
      },
      resetKamItem() {
        let defaults = {
          id: null,
          product_id: null,
          product_name: null,
          quantity: null,
          price: null,
          valid_from: null,
          valid_to: null,
          selectedAddresses: [],
          address_connection: 'only_headquarter',
          delivery_mode: 'everything_at_beginning',
          disclosure: true,
          deliveries: [],
          comment: '',
          proof_sample_size: 0,
          proofs: [],
          classification_id: null,
          custom_classification: []
        }
        this.kamItem = Object.assign(this.kamItem, defaults)
        this.$forceUpdate()
      },
      editProof(kamItem, kamItemIndex)
      {
        this.setActiveKamItem(kamItem)
        this.$refs.proofItemModal.show()
      },
      showAddIcePeakItemModal() {
        this.resetKamItem()
        this.kamItem.mode = 'icepeak'
        this.kamItem.valid_from = this.item.contract_start
        this.kamItem.valid_to = this.item.contract_expiration
        this.selectHCAddresses()
        this.$refs.kamItemModal.show()
      },
      showAddCustomItemModal() {
        this.resetKamItem()
        this.kamItem.mode = 'custom'
        this.kamItem.valid_from = this.item.contract_start
        this.kamItem.valid_to = this.item.contract_expiration
        this.selectHCAddresses()
        this.$refs.kamItemModal.show()
      },
      setActiveKamItem(kamItem) {
        let allAddresses = []
        if (kamItem.address_connection === 'only_headquarter'){
          allAddresses = this.item.addresses.filter(a => a.address_type == 'master').map(a => a.id)
        } else if(kamItem.address_connection === 'all') {
          allAddresses = this.item.addresses.filter(a => a.address_type == 'delivery').map(a => a.id)
        } else {
          allAddresses = kamItem.addresses.map(a => a.address_id)
        }


        if(kamItem.address_connection === "individual" && kamItem.addresses.length === 1) {
          if(this.item.addresses.filter(address => address.id === kamItem.addresses[0].address_id && address.address_type === 'master').length > 0) {
            kamItem.address_connection = 'only_headquarter'
          }
        }

        this.kamItem = {
          id: kamItem.id,
          mode: kamItem.product_id ? 'icepeak' : 'custom',
          price: kamItem.price,
          quantity: kamItem.quantity,
          product_id: kamItem.product_id,
          product_name: kamItem.product_name,
          selectedAddresses: allAddresses,
          selectedProofAddresses: 'proofs' in kamItem ? kamItem.proofs.map(a => a.address_id) : [],
          address_connection: kamItem.address_connection,
          deliveries: kamItem.deliveries,
          delivery_mode: kamItem.deliveries.length == 0 ? 'everything_at_beginning' : 'individual',
          comment: kamItem.comment,
          disclosure: kamItem.disclosure,
          proof_sample_size: kamItem.proof_sample_size,
          valid_from: kamItem.valid_from,
          valid_to: kamItem.valid_to,
          classification_id: kamItem.classification_id,
        }
      },
      editItem(kamItem, kamItemIndex) {
        this.setActiveKamItem(kamItem)
        this.$refs.kamItemModal.show()
      },
      back() {
        this.$router.back()
      },
      contractCanApprovable(approvalFeedback = false) {
        this.approvalFeedback = approvalFeedback
        if(this.item.contract_start && moment().isAfter(this.item.contract_start)) {
          if(this.user.is_super_user) {
            this.$refs.pastContractModel.show()
            return
          } else {
            this.$notify({
              title: this.$i18n.t('core.save_error'),
              text: this.$i18n.t('sandoz.past_contract_error'),
              type: 'error'
            })
            return
          }
        }

        if(this.approvalFeedback) {
          this.saveAndContinueApproval()
        } else {
          this.saveAndStartApproval()
        }
      },
      saveAndStartApproval() {
        // check contract compilnace
        var showComplianceModal = this.checkContractCompliance()
        if(showComplianceModal) {
          this.$refs.compCheckModal.show()
        } else {
          if(this.item.contract_start && moment().isAfter(this.item.contract_start)) {
            if (this.user.is_super_user && !this.item.super_user_comment) {
              this.activeTab = 0
              this.isCommentError = true
              this.$notify({
                title: this.$i18n.t('core.save_error'),
                text: this.$i18n.t('sandoz.super_user_comment_error'),
                type: 'error'
              })
              return
            }
          }

          if(this.fieldVisibility.tabProofOfEvidence && this.item && this.item.type == 'KAM_SD' && this.item.kam_items.length == 0) {
            this.$notify({
              title: this.$i18n.t('core.save_error'),
              text: this.$i18n.t('sandoz.proof_of_evidence_required'),
              type: 'error'
            })
            return
          }

          // check bank information mandatory
          if (this.item.sales_line && this.item.sales_line.bank_information_mandatory === true) {

            let hasSelectedQuantity = false
            if (this.item.kam_items && this.item.kam_items.length) {
              for (let item of this.item.kam_items) {
                if (Number(item.quantity || 0) > 0) {
                  hasSelectedQuantity = true
                  break
                }
              }
            }

            if (hasSelectedQuantity) {
              const validations = [
                { field: 'bank_name', message: this.$i18n.t('sandoz.bank_name_required') },
                { field: 'bank_address', message: this.$i18n.t('sandoz.bank_address_required') },
                { field: 'accountholder_name', message: this.$i18n.t('sandoz.account_holder_name_required') },
                { field: 'accountholder_address', message: this.$i18n.t('sandoz.account_holder_address_required') },
                { field: 'iban_no', message: this.$i18n.t('sandoz.iban_no_required') },
              ]

              for (let v of validations) {
                const value = this.item[v.field]

                if (!value || value.trim() === '' || value.trim() === null) {
                  this.$notify({
                    title: this.$i18n.t('core.validation_error'),
                    text: this.$i18n.t('core.validation_error_text', { message: v.message }),
                    type: 'error'
                  })
                  return
                }
              }
            }
          }

          this.item.status = 'Committed'
          this.save()
        }
      },
      saveAndContinueApproval() {
        if(this.item.contract_start && moment().isAfter(this.item.contract_start)) {
          if (this.user.is_super_user && !this.item.super_user_comment) {
            this.activeTab = 0
            this.isCommentError = true
            this.$notify({
              title: this.$i18n.t('core.save_error'),
              text: this.$i18n.t('sandoz.super_user_comment_error'),
              type: 'error'
            })
            return
          }
        }

        if(this.fieldVisibility.tabProofOfEvidence && this.item && this.item.type == 'KAM_SD' && this.item.kam_items.length == 0) {
          this.$notify({
            title: this.$i18n.t('core.save_error'),
            text: this.$i18n.t('sandoz.proof_of_evidence_required'),
            type: 'error'
          })
          return
        }

        // check bank information mandatory
        if (this.item.sales_line && this.item.sales_line.bank_information_mandatory === true) {
          let hasSelectedQuantity = false
          if (this.item.kam_items && this.item.kam_items.length) {
            for (let item of this.item.kam_items) {
              if (Number(item.quantity || 0) > 0) {
                hasSelectedQuantity = true
                break
              }
            }
          }

          if (hasSelectedQuantity) {
            const validations = [
              { field: 'bank_name', message: this.$i18n.t('sandoz.bank_name_required') },
              { field: 'bank_address', message: this.$i18n.t('sandoz.bank_address_required') },
              { field: 'accountholder_name', message: this.$i18n.t('sandoz.account_holder_name_required') },
              { field: 'accountholder_address', message: this.$i18n.t('sandoz.account_holder_address_required') },
              { field: 'iban_no', message: this.$i18n.t('sandoz.iban_no_required') },
            ]

            for (let v of validations) {
              const value = this.item[v.field]

              if (!value || value.trim() === '' || value.trim() === null) {
                this.$notify({
                  title: this.$i18n.t('core.validation_error'),
                  text: this.$i18n.t('core.validation_error_text', { message: v.message }),
                  type: 'error'
                })
                return
              }
            }
          }
        }

        this.item.status = 'Committed'
        this.item.approval_feedback = null
        this.save()
      },
      save() {
        var url = this.url
        var route = this.$route

        // this happens if we create a new data record and update it right away without navigating way. We'll still have
        // new in our url, but we don't want to create a new record, we want to update the record we just created.
        // @TODO we should do this in a more elegant way that doesn't require search & replace
        if (url.indexOf('/new') > 0 && 'id' in this.item) {
          url = url.replace('/new', '/' + this.item.id)
        }

        var root = this.$root
        var self = this

        if(self.item.type ===  null) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.type_required') }),
            type: 'error'
          })
          return
        }

        if(self.item.customer_external_id ===  null) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.external_id_required') }),
            type: 'error'
          })
          return
        }

        if(self.item.contract_year ===  null) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.contract_year_required') }),
            type: 'error'
          })
          return
        }

        if(self.item.new_customer === 'NA') {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.new_customer_required') }),
            type: 'error'
          })
          return
        }

        if(self.item.new_customer === null && (self.item.previous_contract === undefined || self.item.previous_contract === null)) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.previous_contract_required') }),
            type: 'error'
          })
          return
        }

        if(self.item.marketing_activities > 0 && (self.item.kam_items && self.item.kam_items.length <= 0)) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.item_missing_error') }),
            type: 'error'
          })
          return
        }

        if(self.checkDiscountGXAccrual() || self.checkDiscountOTCAccrual()) {
          return
        }

        this.disableWatchers()
        if (this.$refs.pastContractModel && this.$refs.pastContractModel.isVisible) {
          this.$refs.pastContractModel.hide()
        }

        this.saving = true

        axios
          .post(url, this.item)
          .then((response) => {
            this.item = response.data

            // assign our new id to the route params in case someone wants to work with it
            if ('id' in response.data) {
              route.params.id = response.data.id
            }

            this.$notify({
              title: this.$i18n.t('core.saved'),
              text: this.$i18n.t('core.saved_text')
            })

            // remove all error states
            var elements = document.querySelectorAll('.has-error')
            elements.forEach((element) => {
              element.classList.remove('has-error')
            })

            // clear all errors
            root.errors = {}
            self.isCommentError = false

            // stop loading indicator
            self.saving = false
            self.showDeletedFiles = false
            self.showDeletedPDFFiles = false

            this.enableWatchers()
          })
          .catch((error) => {
            // stop loading indicator
            self.saving = false

            if (error.response.status === 422 && 'data' in error.response && 'message' in error.response.data) {
              this.$notify({
                title: this.$i18n.t('core.validation_error'),
                text: this.$i18n.t('core.validation_error_text', {message: error.response.data.message}),
                type: 'error'
              })
              if ('data' in error.response && 'errors' in error.response.data) {
                root.errors = error.response.data.errors
              }
            } else {
              this.$notify({
                title: this.$i18n.t('core.save_error'),
                text: this.$i18n.t('core.save_error_text', {url: this.url}),
                type: 'error'
              })
            }
          })
      },
      addAddress() {
        this.addressMode = 'delivery',
        this.showAddressModeCheckbox = false
        this.$refs.addressSearch.showAddressSearchModal(this)
      },
      setMasterAddress() {
        this.addressMode = 'master'
        // only sortalys contracts can have multiple contracts for a single practice
        this.showAddressModeCheckbox = this.sortalysContract
        this.$refs.addressSearch.showAddressSearchModal(this)
      },
      addressSelected(addressEvent) {
        let address = addressEvent.address
        let multipleContractsPerPractice = addressEvent.multipleContractsPerPractice
        let owningComponent = addressEvent.owningComponent
        let owningComponentData = owningComponent.$data


        // set external id
        let externalId = multipleContractsPerPractice ? address.external_id : address.org_external_id

        if (this.item.type !== 'KAM_WHS' && externalId && !externalId.startsWith('CH_PBG')) {
          this.pendingAddressEvent = addressEvent;
          this.$refs.kamWarningModal.show();
          return;
        }

        this.processAddressSelection(addressEvent);
      },
      confirmKamWarning() {
        if (this.pendingAddressEvent) {
          this.processAddressSelection(this.pendingAddressEvent);
          this.pendingAddressEvent = null;
        } else if (this.pendingAddressBulkResponse) {
          this.processBulkAddressSelection(this.pendingAddressBulkResponse);
          this.pendingAddressBulkResponse = null;
        }
        this.$refs.kamWarningModal.hide();
      },
      cancelKamWarning() {
        this.pendingAddressEvent = null;
        this.pendingAddressBulkResponse = null;
        this.$refs.kamWarningModal.hide();
      },
      processAddressSelection(addressEvent) {
        let address = addressEvent.address
        let multipleContractsPerPractice = addressEvent.multipleContractsPerPractice
        let owningComponent = addressEvent.owningComponent
        let owningComponentData = owningComponent.$data

        let externalId = multipleContractsPerPractice ? address.external_id : address.org_external_id

        switch (this.addressMode) {
          case 'master':
            owningComponentData.item.customer_external_id = externalId

            let masterAddressData = {
              id: 'NEW_TEMP_ID_' + (++this.newObjectCounter),
              del_address: 1,
              address_type: 'master',
              company_name: address.org_full_name,
              street: address.org_street,
              zip: address.org_zip_code,
              city: address.org_city,
              customer_external_id: externalId,
              customer_external_id_hcp: address.external_id,
              customer_size: address.org_pharmacy_classification
            }

            // we have to set a dynamic ID so that we can relate to our unsaved object.
            // this will later be replaced when saving the object. In the future we might want
            // to use GUIDs to avoid this ugly hack
            masterAddressData.id = 'NEW_TEMP_ID_' + (++this.newObjectCounter)

            if (owningComponentData.item.addresses.length > 0) {
              owningComponentData.item.addresses[0] = masterAddressData
            }
            else {
              owningComponentData.item.addresses.push(masterAddressData)
            }

            // set bank data
            owningComponentData.item.vat_number = address.org_vat
            owningComponentData.item.bank_name = address.org_bank_name
            owningComponentData.item.bank_address = address.org_bank_address
            owningComponentData.item.accountholder_name = address.org_bank_account
            owningComponentData.item.accountholder_address = address.org_bank_account_address


            this.loadplanData()

            break
          case 'delivery':
            owningComponentData.item.addresses.push({
              id: 'NEW_TEMP_ID_' + (++this.newObjectCounter),
              del_address: owningComponentData.item.addresses.length + 1,
              address_type: 'delivery',
              company_name: address.org_full_name,
              street: address.org_street,
              zip: address.org_zip_code,
              city: address.org_city,
              customer_external_id: externalId,
              customer_external_id_hcp: address.external_id,
              customer_size: address.org_pharmacy_classification
            })
            break
        }
      },
      addSubAddresses() {
        if (this.item.addresses.length > 1) {
          this.$refs.subAddressModal.show()
        }
        else {
          this.addSubAddressesImpl()
        }
      },
      clearAndAddSubAddressesImpl() {
        this.item.addresses.splice(1)
        this.addSubAddressesImpl()
      },
      addSubAddressesImpl() {
        this.$refs.subAddressModal.hide()
        this.subAddressProcessActive = true

        axios.get(`/api/sandoz/kam/contracts/get-child-addresses/${this.item.customer_external_id}`).then(response => {
          let addressCount = this.item.addresses.length
          var addresses = response.data.map(address => ({
              id: 'NEW_TEMP_ID_' + (++this.newObjectCounter),
              del_address: ++addressCount,
              address_type: 'delivery',
              company_name: address.parent.full_name,
              street: address.parent.street,
              zip: address.parent.zip_code,
              city: address.parent.city,
              customer_external_id: address.external_id,
              customer_external_id_hcp: address.external_id,
              customer_size: address.extension ? address.extension.pharmacy_classification : ''
            }))

          this.item.addresses.push(...addresses)
          this.subAddressProcessActive = false
        })
      },
      loadData() {
        this.url = `/api/sandoz/kam/contracts/${this.$route.params.id}?transformer=kam&include=addresses,proofs,kam_items,kam_items.addresses,kam_items.deliveries,kam_items.proofs,kam_items.custom_classification,word_files.user,checks,pdfs.user`
        axios
          .get(this.url)
          .then((response) => {
            var item = response
            if (this.dataKey) {
              item = response[this.dataKey]
            }
            this.item = item.data
            this.updateContractYears()

            // set default user
            if (!this.item.user_id) {
              this.item.user_id = this.user.id
            }

            this.$nextTick(() => {
              this.loaded = true
            })

            this.enableWatchers()
            this.setFieldVisibility()
            this.loadplanData()
          })

      },
      addExternalId(externalId)  {
        this.item.customer_external_id = externalId
        this.$refs.addExternalIdModel.hide()
      },
      setContractNo() {
        if (!this.item.type || !this.item.customer_external_id) {
          return
        }
        this.item.contract_no = `${this.item.type}-${this.item.contract_year-2000}-${this.item.customer_external_id}` + (this.item.contract_no_suffix ? ('-' + this.item.contract_no_suffix) : '')
      },
      setContractDates(year) {
        const currentDate = moment()
        if(currentDate.year() === parseInt(year)) {
          if(currentDate < moment(currentDate.year() + '-03-31', 'YYYY-MM-DD') || currentDate.month() > 8) {
            this.item.contract_start = year + '-01-01'
          } else {
            this.item.contract_start = currentDate.startOf('month').format('YYYY-MM-DD')
          }
        } else {
          this.item.contract_start = year + '-01-01'
        }

        this.item.contract_expiration = year + '-12-31'
      },
      setApprovers() {
        if (this.item.status != 'Draft' && this.item.status != 'Feedback') {
          return
        }
        if (!this.item.type) {
          return
        }
        if (!this.currentUser) {
          return
        }



        if(this.sortalysContract) {
          this.setApprover(1, 'Channel Head')
          var approverCount = 2
          for (var i = approverCount; i <= 6; i++) {
            this.clearApprover(i)
            this.clearApproverRole(i)
          }
        } else {

          var investZeroError = false
          /* Disable below due to #1426: Disable planning file approval for KAM
          if(this.item.turnover_gx <= 0 || this.item.turnover_gx_expectation <= 0 || this.item.marketing_activities_gx <= 0 || this.item.marketing_activities_percentage <= 0 ||
          this.item.turnover_otc <= 0 || this.item.turnover_otc_expectation <= 0 || this.item.marketing_activities_otc <= 0 || this.item.marketing_activities_percentage_otc <= 0
          ) {
            investZeroError = true
            this.item.deviation_outside_margin = null
          }
          */

          // No deviation if plandata null
          if(this.planData === null) {
            this.item.deviation_outside_margin = null
          }

          if((this.item.sales_line && this.item.sales_line.automatic_approval_allowed === true) && this.planData !== null) {
            if((this.plan_turnover_expectation_condition === true || this.plan_invest_condition === true ||  this.plan_discount_condition === true || this.plan_turnover_expectation_condition_otc === true || this.plan_invest_condition_otc === true ||  this.plan_discount_condition_otc === true) &&
              (this.plan_turnover_outside_range !== true && this.plan_turnover_expectation_outside_range !== true && this.plan_invest_outside_range !== true && this.plan_discount_outside_range !== true && this.plan_turnover_outside_range_otc !== true && this.plan_turnover_expectation_outside_range_otc !== true && this.plan_invest_outside_range_otc !== true && this.plan_discount_outside_range_otc !== true)
            ) {
              this.item.deviation_outside_margin = 0
            }

            if((this.plan_turnover_expectation_condition === true || this.plan_invest_condition === true ||  this.plan_discount_condition === true || this.plan_turnover_expectation_condition_otc === true || this.plan_invest_condition_otc === true ||  this.plan_discount_condition_otc === true) &&
              (this.plan_turnover_outside_range === true || this.plan_turnover_expectation_outside_range === true || this.plan_invest_outside_range == true || this.plan_discount_outside_range == true && this.plan_turnover_outside_range_otc !== true || this.plan_turnover_expectation_outside_range_otc === true || this.plan_invest_outside_range_otc === true || this.plan_discount_outside_range_otc === true)
            ) {
              this.item.deviation_outside_margin = 1
            }

          }

          if((investZeroError === false && (Math.sign(this.item.marketing_activities - this.priceTotal) === -1 || this.planData === null || (this.item.sales_line && this.item.sales_line.automatic_approval_allowed === false)) ||
            ( Math.sign(this.item.marketing_activities - this.priceTotal) !== -1 && (this.item.sales_line && this.item.sales_line.automatic_approval_allowed === true) && this.item.plan_deviation_skip_approval === false && this.planData !== null &&
              ((this.plan_turnover_outside_range === true) || (this.plan_turnover_expectation_condition === true) || (this.plan_invest_condition === true) || (this.plan_discount_condition === true) || (this.plan_turnover_expectation_condition_otc === true) || (this.plan_invest_condition_otc === true) || (this.plan_discount_condition_otc === true)))
          )) {

            if (this.item.type == 'KAM_DIVERSE' || this.item.type == 'KAM_DIVERSE_INSUR' || this.item.type == 'KAM_DIVERSE_HOSP') {
              this.item.contract_year >= 2025 ? this.setApprover(1, 'Legal & Compliance') : this.setApprover(1, 'Legal')
              this.setApprover(2, 'Channel Head')

              if ((Number(this.item.marketing_activities || 0) + Number(this.item.discount || 0)) >= 150000) {
                this.setApprover(3, 'CFO')
              }
              else {
                this.setApprover(3, 'BPA')
              }
            }
            else {
              if (this.item.contract_year >= 2024) {
                var approverCount = 1
                var invest = Number(this.item.marketing_activities || 0) + Number(this.item.discount || 0)
                this.setApprover(approverCount++, 'Channel Head')
                if (invest >= 250_000) {
                  this.setApprover(approverCount++, 'BU Head Retail')
                }

                this.item.contract_year >= 2025 ? this.setApprover(approverCount++, 'Legal & Compliance') : this.setApprover(approverCount++, 'Compliance')
                this.setApprover(approverCount++, invest >= 250_000 ? 'CFO' : 'BPA')
                if (invest >= 2_500_000) {
                  this.setApprover(approverCount++, 'GM')
                }

                if(this.item.contract_year <= 2024) {
                  this.setApprover(approverCount++, 'Legal')
                }

                for (var i = approverCount; i <= 6; i++) {
                  this.clearApprover(i)
                  this.clearApproverRole(i)
                }
              }
              else {
                this.setApprover(1, 'Compliance')
                this.setApprover(2, 'Legal')
                if (['KAM_WHS', 'BIOS_KAM_WHS'].includes(this.item.type)) {
                  this.setApprover(3, 'BU Head Retail')
                }
                else {
                  this.setApprover(3, 'Channel Head')
                }

                if ((Number(this.item.marketing_activities || 0) + Number(this.item.discount || 0)) >= 150000) {
                  this.setApprover(4, 'CFO')
                }
                else {
                  this.setApprover(4, 'BPA')
                }
                if (!(['KAM_WHS', 'BIOS_KAM_WHS'].includes(this.item.type))) {
                  this.setApprover(5, 'Legal')
                }
              }

            }
          } else {
            var approvers = [1,2,3,4,5,6];
            for(var i=1; i<=approvers.length; i++) {
              this.setApprover(i, null)
            }

            if(investZeroError === false && this.item.plan_deviation_skip_approval === false) {
              this.item.deviation_outside_margin = null
            }
          }
        }

        this.$forceUpdate()
      },
      clearApproverRole(i) {
        this.item['approver_' + i] = null
      },
      clearApprover(i) {
        this.item['approval_date_' + i] = null
        this.item['approval_person_' + i] = null
      },
      setApprover(num, val) {
        if (this.item['approver_' + num] != val) {
          this.item['approver_' + num] = val

          // clear existing
          for (let i = num; i < 6; i++) {
            this.clearApprover(i)
          }

          // reset next approver if needed
          this.item.next_approver = Math.min(this.item.next_approver, num)
        }
      },
      checkContractCompliance() {
        var showComplianceModal = false

        if (this.fieldVisibility.tabChecklist === false) {
          return false
        }

        var checkContractReviewBoard = this.item.checks.filter(check => {
          return check.selected === true && check.responsible === 'Contract Review Board'
        })

        if(checkContractReviewBoard && Object.keys(checkContractReviewBoard).length > 0) {
          this.complianceReviewBoard = true
        } else {
          this.complianceReviewBoard = false
        }

        var checkComplianceOnly = this.item.checks.filter(check => {
          return check.selected === true && check.responsible === 'Compliance only'
        })

        if(checkComplianceOnly && Object.keys(checkComplianceOnly).length > 0) {
          this.complianceOnly = true
        } else {
          this.complianceOnly = false
        }

        if(this.complianceReviewBoard === true || this.complianceOnly === true) {
          showComplianceModal = true
        }

        return showComplianceModal
      },
      addComplianceData() {
        this.$refs.compCheckModal.hide()

        if(this.complianceReviewBoard !== true) {
          this.item.compilance_check_file = null;
        }

        if(this.complianceOnly !== true) {
          this.item.compilance_check_selected = null;
          this.item.compilance_check_note = null;
        } else {
          this.item.compilance_check_selected = this.complianceSelect === "true" ? 1 : 0
        }

        this.item.status = 'Committed'
        this.save()
      },
      downloadTemplate() {
        var file = 'kam_checklist_template.pptx';
        axios.get('/api/sandoz/kam/download_template?file='+file, {responseType: 'arraybuffer'})
        .then((response) => {
          require('downloadjs')(
              response.data,
              file
          )
        }).catch((error) => {
          console.log(error)
        })
      },
      disableValidFromDates(year) {
        if(!year) {
          return {}
        }

        return {
          to: new Date(parseInt(year), 0, 1),
          from: new Date(parseInt(year), 11, 31)
        }
      },
      disableValidToDates(validFrom) {
        if(!validFrom) {
          return {}
        }

        const date = validFrom.split(/[\s-]+/)
        return {
          to: new Date(parseInt(date[0]), parseInt(date[1]) - 1, parseInt(date[2]) + 1),
          from: new Date(parseInt(date[0]) + 1, 0, 1)
        }
      },
      downloadPreApproveExcel() {
        var file = 'pre_approval_check.xlsx';
        axios.get('/api/sandoz/kam/download_template?file='+file, {responseType: 'arraybuffer'})
        .then((response) => {
          require('downloadjs')(
              response.data,
              file
          )
        }).catch((error) => {
          console.log(error)
        })
      },
      addPreviousContract (contract) {
        this.item.previous_contract = contract.id
        this.item.previous = contract
        this.$refs.addPreviousContractModel.hide()
      },
      setPreviousContract (fromNewCustomer = false) {
        if(this.item.customer_external_id !== null && this.item.contract_year !== '' && this.item.type !== null) {
          var params = {
            customer_external_id: this.item.customer_external_id,
            contract_year: this.item.contract_year,
            type: this.item.type
          }
          let url = '/api/sandoz/ice-peak/contracts/get-previous-contract';
          axios.post(url, params)
            .then((response) => {
              const self = this
              let previousContract = response.data.previousContract
              if(previousContract) {
                self.item.previous_contract = previousContract.id
                self.item.previous = previousContract
                if(!fromNewCustomer) {
                  self.item.new_customer = null
                }
              } else {
                self.item.previous_contract = null
                self.item.previous = null
                if(!fromNewCustomer) {
                  self.item.new_customer = 'x'
                }
              }
            })
        }
      },
      pdfContract() {
        this.saving = true
        this.$root.$loading.start()
        let delAddress = null
        this.item.addresses.forEach(function (address, key) {
          if (address.address_type === 'master' && delAddress === null) {
            delAddress = address
          }
        })

        let documentName = this.item.contract_no;
        if(this.item.contract_version !== null) {
          documentName += '-'+this.item.contract_version
        }else {
          documentName += '-1';
        }

        if(delAddress) {
          documentName += '-'+delAddress.company_name+' - '+delAddress.city
        }

        axios.post('/api/sandoz/generate-pdf2', {id:this.$route.params.id}, { responseType: 'arraybuffer' })
          .then((response) => {
            require('downloadjs')(
              response.data,
              documentName+'.pdf',
              'application/pdf'
            )
            this.$root.$loading.finish()
            this.saving = false
          }).catch((error) => {
          this.$root.$loading.finish()
          this.saving = false
          console.log(error)
        })
      },
      setCurrentUser(user) {
        if (!user) {
          return
        }

        this.currentUser = user

        if (user.regions && user.regions.data && Object.keys(user.regions.data).length) {
          this.item.region_id = user.regions.data[0].region_id
        } else {
          this.item.region_id = null
        }
      },
      loadplanData() {
        if(this.item.contract_year && this.item.type && this.item.customer_external_id && (this.item.status === 'Draft' || this.item.status === 'Feedback')) {
          let url = '/api/loadplanData?type='+this.item.type+'&year='+this.item.contract_year+'&external_id='+this.item.customer_external_id
          axios
          .get(url)
          .then((response) => {
            var planData = response.data.planData
            this.planData = planData
            if(planData) {
              this.item.plan_gx_outlook = parseInt(planData.gx_turnover_actual)
              if(planData.gx_outlook != "" && planData.gx_outlook != "0") {
                this.item.plan_gx_turnover_actual = parseInt(planData.gx_outlook)
              } else {
                this.item.plan_gx_turnover_actual = null
              }

              this.item.plan_gx_turnover_expectation = planData.gx_turnover_expectation !== null ? this.calculatePriceBasedonDuration(parseInt(planData.gx_turnover_expectation)) : null
              this.item.plan_gx_target_invest = planData.gx_target_invest !== null ? this.calculatePriceBasedonDuration(parseInt(planData.gx_target_invest)) : null
              this.item.plan_gx_turnover_actual = this.item.plan_gx_turnover_actual !== null ? this.calculatePriceBasedonDuration(parseInt(this.item.plan_gx_turnover_actual)) : null
              this.item.plan_gx_target_discount = planData.gx_target_discount !== null ? this.calculatePriceBasedonDuration(parseInt(planData.gx_target_discount)) : null
              // set planned activity percentage
              if(this.item.plan_gx_turnover_expectation !== 0 && this.item.plan_gx_turnover_expectation !== null && this.item.plan_gx_target_invest !== 0 && this.item.plan_gx_target_invest !== null) {
                this.marketing_activities_percentage =  this.item.plan_gx_target_invest / this.item.plan_gx_turnover_expectation
              }


              // set discount percentage
              if(this.item.turnover_gx_expectation !== 0 && this.item.turnover_gx_expectation !== null && this.item.plan_gx_target_discount !== 0 && this.item.plan_gx_target_discount !== null) {
                this.discount_percentage =  this.item.plan_gx_target_discount / this.item.turnover_gx_expectation
              }

              if(this.$route.params.id === 'new' || parseInt(this.item.turnover_gx_expectation) === 0) {
                this.item.turnover_gx_expectation = parseInt(planData.gx_turnover_expectation)
              }

              if((this.$route.params.id === 'new' && parseInt(this.item.marketing_activities_gx) === 0) || parseInt(this.item.marketing_activities_gx) === 0) {
                this.item.marketing_activities_gx = this.roundToWhole(planData.gx_target_invest)
              }

              if(this.$route.params.id === 'new' || Number.isNaN(this.item.turnover_gx) || isNaN(parseFloat(this.item.turnover_gx)) || parseInt(this.item.turnover_gx) === 0) {
                if(this.checkTurnOverReadonly()) {
                  this.item.turnover_gx = this.roundToWhole(this.item.plan_gx_turnover_actual)
                }
              }

              this.item.plan_otc_outlook = parseInt(planData.otc_turnover_actual)
              if(planData.otc_outlook != "" && planData.otc_outlook != "0") {
                this.item.plan_otc_turnover_actual = parseInt(planData.otc_outlook)
              } else {
                this.item.plan_otc_turnover_actual = null
              }

              this.item.plan_otc_turnover_expectation = planData.otc_turnover_expectation !== null ? this.calculatePriceBasedonDuration(parseInt(planData.otc_turnover_expectation)) : null
              this.item.plan_otc_target_invest = planData.otc_target_invest !== null ? this.calculatePriceBasedonDuration(parseInt(planData.otc_target_invest)) : null
              this.item.plan_otc_turnover_actual = this.item.plan_otc_turnover_actual !== null ? this.calculatePriceBasedonDuration(parseInt(this.item.plan_otc_turnover_actual)) : null
              this.item.plan_otc_target_discount = planData.otc_target_discount !== null ? this.calculatePriceBasedonDuration(parseInt(planData.otc_target_discount)) : null
              // set planned activity percentage
              if(this.item.plan_otc_turnover_expectation !== 0 && this.item.plan_otc_turnover_expectation !== null && this.item.plan_otc_target_invest !== 0 && this.item.plan_otc_target_invest !== null) {
                this.marketing_activities_percentage_otc =  this.item.plan_otc_target_invest / this.item.plan_otc_turnover_expectation
              }


              // set discount percentage
              if(this.item.turnover_otc_expectation !== 0 && this.item.turnover_otc_expectation !== null && this.item.plan_otc_target_discount !== 0 && this.item.plan_otc_target_discount !== null) {
                this.discount_percentage_otc =  this.item.plan_otc_target_discount / this.item.turnover_otc_expectation
              }

              if(this.$route.params.id === 'new' || parseInt(this.item.turnover_gx_expectation) === 0) {
                this.item.turnover_otc_expectation = parseInt(planData.otc_turnover_expectation)
              }

              if((this.$route.params.id === 'new' && parseInt(this.item.marketing_activities_otc) === 0) || parseInt(this.item.marketing_activities_otc) === 0) {
                this.item.marketing_activities_otc = this.roundToWhole(planData.otc_target_invest)
              }

              if(this.$route.params.id === 'new' || Number.isNaN(this.item.turnover_otc) || isNaN(parseFloat(this.item.turnover_otc)) || parseInt(this.item.turnover_otc) === 0) {
                if(this.checkTurnOverReadonlyOtc()) {
                  this.item.turnover_otc = this.roundToWhole(this.item.plan_otc_turnover_actual)
                }
              }


            } else {

              this.item.plan_gx_outlook = null
              this.item.plan_gx_turnover_expectation = null
              this.item.plan_gx_target_invest = null
              this.item.plan_gx_target_discount =  null
              this.item.plan_gx_turnover_actual = null
              this.marketing_activities_percentage = null
              this.item.deviation_outside_margin = null

              this.item.plan_otc_outlook = null
              this.item.plan_otc_turnover_expectation = null
              this.item.plan_otc_target_invest = null
              this.item.plan_otc_target_discount =  null
              this.item.plan_otc_turnover_actual = null
              this.marketing_activities_percentage_otc = null
              this.item.deviation_outside_margin_otc = null

              this.discount_percentage = null
              this.discount_percentage_otc = null


              if(this.$route.params.id === 'new') {
                this.item.turnover_gx_expectation = 0
                this.item.marketing_activities_gx = 0
                this.item.turnover_otc_expectation = 0
                this.item.marketing_activities_otc = 0
              }
            }

            const self = this

            self.$nextTick(() => {
              self.calculatePlanTurnOverExpectation()
              self.calculatePlanTargetInvest()
              self.calculatePlanTargetDiscount()
              self.sumGxOtc()
              self.setAccrualLabels()
              self.originalKukos = null
              self.loadKukoDiscount()
            })
          })
        }
      },
      calculatePriceBasedonDuration(val) {
        // if(val !== null && val !== 0 && val !== 0.00 && this.item && this.$route.params.id === 'new') {
        //   var contractStart = this.item.contract_start
        //   var contractExpiration = this.item.contract_expiration
        //   contractStart = contractStart === null ? 12 : parseInt(moment(contractStart).format('MM'))
        //   contractExpiration = contractExpiration === null ? 12 : parseInt(moment(contractExpiration).format('MM'))
        //   var durationVal = (val / 12) * ((contractExpiration - contractStart) + 1)
        //   return parseInt(durationVal)
        // }
        return val
      },
      formatDescription(value) {
        if(value) {
          return this.$options.filters.formatInteger(value);
        }
        return null
      },
      getPlanDataTurnoverActual() {
        if(this.planData && (this.item.status === 'Draft' || this.item.status === 'Feedback')) {

          if(this.planData.gx_turnover_actual !== null) {
            var planBaseline= this.calculatePriceBasedonDuration(parseInt(this.planData.gx_turnover_actual))
            this.item.plan_gx_outlook = planBaseline
            return planBaseline
          }
        }else if(this.item.plan_gx_outlook !== null && this.item.plan_gx_outlook !== '') {
          return this.calculatePriceBasedonDuration(parseInt(this.item.plan_gx_outlook))
        }
        return null
      },
      calculatePlanTurnOverExpectation() {
        var planTurnOverExpectation = null
        if(this.item.plan_gx_turnover_expectation !== 0 && this.item.plan_gx_turnover_expectation !== null){
          planTurnOverExpectation = this.item.plan_gx_turnover_expectation
        }

        var contractTurnOverExpectation = parseInt(this.item.turnover_gx_expectation)
        if(contractTurnOverExpectation !== 0 && planTurnOverExpectation !== null && this.item.sales_line) {

          if(contractTurnOverExpectation < parseInt(planTurnOverExpectation)) {
            var rangePercentage = this.checkDifferenceAndGetPercDeviation(contractTurnOverExpectation)
            if(rangePercentage !== null && rangePercentage !== 0 && rangePercentage !== 0.00) {
              this.plan_turnover_expectation_condition = true
              var maxDeviationValue = parseInt(planTurnOverExpectation) - (parseInt(planTurnOverExpectation)*rangePercentage)
              if(parseFloat(contractTurnOverExpectation) < parseFloat(maxDeviationValue)) {
                this.item.plan_deviation_skip_approval = false
                this.plan_turnover_expectation_outside_range = true
                return 'text-danger';
              } else {
                this.plan_turnover_expectation_outside_range = null
                return 'text-muted';
              }
            }
          } else {
            this.plan_turnover_expectation_condition = false
            this.plan_turnover_expectation_outside_range = null
            return 'text-muted';
          }
        } else {
          this.plan_turnover_expectation_outside_range = null
        }
        return 'text-muted';
      },
      checkDifferenceAndGetPercDeviation(val) {
        if(this.item.sales_line) {
          if(val > 0 && val <= 10000) {
            return this.item.sales_line.deviation_range_1
          } else if(val > 10000 && val <= 20000) {
            return this.item.sales_line.deviation_range_2
          } else if(val > 20000) {
            return this.item.sales_line.deviation_range_3
          }
        }
        return null
      },
      calculatePlanTargetInvest() {
        var planTargetInvest = null
        if(this.item.plan_gx_target_invest !== 0 && this.item.plan_gx_target_invest !== null){
          planTargetInvest = this.item.plan_gx_target_invest
        }
        var contractTargetInvest = parseInt(this.item.marketing_activities_gx)
        if(contractTargetInvest !== 0 && planTargetInvest !== null && this.item.sales_line) {
          if(contractTargetInvest > parseInt(planTargetInvest)) {
            var rangePercentage = this.checkDifferenceAndGetPercDeviation(contractTargetInvest)
            if(rangePercentage !== null && rangePercentage !== 0 && rangePercentage !== 0.00) {
              this.plan_invest_condition = true
              var maxDeviationValue = parseInt(planTargetInvest) + (parseInt(planTargetInvest)*rangePercentage)
              if(parseFloat(contractTargetInvest) > parseFloat(maxDeviationValue)) {
                this.item.plan_deviation_skip_approval = false
                this.plan_invest_outside_range = true
                return 'text-danger';
              } else {
                this.plan_invest_outside_range = null
                return 'text-muted';
              }
            }
          } else {
            this.plan_invest_condition = false
            this.plan_invest_outside_range = null
            return 'text-muted';
          }
        } else {
          this.plan_invest_outside_range = null
        }
        return 'text-muted';
      },
      calculatePlanTargetDiscount() {
        var planTargetDiscount = null
        if(this.item.plan_gx_target_discount !== 0 && this.item.plan_gx_target_discount !== null){
          planTargetDiscount = this.item.plan_gx_target_discount
        }

        var contractTargetDiscount = parseInt(this.item.discount_gx)
        if(contractTargetDiscount !== 0 && planTargetDiscount !== null && planTargetDiscount != 0.00 && this.item.sales_line) {
          if(contractTargetDiscount > parseInt(planTargetDiscount)) {
            var rangePercentage = this.checkDifferenceAndGetPercDeviation(contractTargetDiscount)
            if(rangePercentage !== null && rangePercentage !== 0 && rangePercentage !== 0.00) {
              this.plan_discount_condition = true
              var maxDeviationValue = parseInt(planTargetDiscount) + (parseInt(planTargetDiscount)*rangePercentage)
              if(parseFloat(contractTargetDiscount) > parseFloat(maxDeviationValue)) {
                this.item.plan_deviation_skip_approval = false
                this.plan_discount_outside_range = true
                return 'text-danger';
              } else {
                this.plan_discount_outside_range = null
                return 'text-muted';
              }
            }
          } else {
            this.plan_discount_condition = false
            this.plan_discount_outside_range = null
            return 'text-muted';
          }
        } else {
          this.plan_discount_outside_range = null
        }
        return 'text-muted';
      },
      getPlanDataTurnoverActualOtc() {
        if(this.planData && (this.item.status === 'Draft' || this.item.status === 'Feedback')) {

          if(this.planData.otc_turnover_actual !== null) {
            var planBaseline= this.calculatePriceBasedonDuration(parseInt(this.planData.otc_turnover_actual))
            this.item.plan_otc_outlook = planBaseline
            return planBaseline
          }
        }else if(this.item.plan_otc_outlook !== null && this.item.plan_otc_outlook !== '') {
          return this.calculatePriceBasedonDuration(parseInt(this.item.plan_otc_outlook))
        }
        return null
      },
      calculatePlanTurnOverExpectationOtc() {
        var planTurnOverExpectation = null
        if(this.item.plan_otc_turnover_expectation !== 0 && this.item.plan_otc_turnover_expectation !== null){
          planTurnOverExpectation = this.item.plan_otc_turnover_expectation
        }

        var contractTurnOverExpectation = parseInt(this.item.turnover_otc_expectation)
        if(contractTurnOverExpectation !== 0 && planTurnOverExpectation !== null && this.item.sales_line) {

          if(contractTurnOverExpectation < parseInt(planTurnOverExpectation)) {
            var rangePercentage = this.checkDifferenceAndGetPercDeviation(contractTurnOverExpectation)
            if(rangePercentage !== null && rangePercentage !== 0 && rangePercentage !== 0.00) {
              this.plan_turnover_expectation_condition_otc = true
              var maxDeviationValue = parseInt(planTurnOverExpectation) - (parseInt(planTurnOverExpectation)*rangePercentage)
              if(parseFloat(contractTurnOverExpectation) < parseFloat(maxDeviationValue)) {
                this.item.plan_deviation_skip_approval = false
                this.plan_turnover_expectation_outside_range_otc = true
                return 'text-danger';
              } else {
                this.plan_turnover_expectation_outside_range_otc = null
                return 'text-muted';
              }
            }
          } else {
            this.plan_turnover_expectation_condition_otc = false
            this.plan_turnover_expectation_outside_range_otc = null
            return 'text-muted';
          }
        } else {
          this.plan_turnover_expectation_outside_range_otc = null
        }
        return 'text-muted';
      },
      calculatePlanTargetDiscountOtc() {
        var planTargetDiscount = null
        if(this.item.plan_otc_target_discount !== 0 && this.item.plan_otc_target_discount !== null){
          planTargetDiscount = this.item.plan_otc_target_discount
        }

        var contractTargetDiscount = parseInt(this.item.discount_otc)
        if(contractTargetDiscount !== 0 && planTargetDiscount !== null && planTargetDiscount != 0.00 && this.item.sales_line) {
          if(contractTargetDiscount > parseInt(planTargetDiscount)) {
            var rangePercentage = this.checkDifferenceAndGetPercDeviation(contractTargetDiscount)
            if(rangePercentage !== null && rangePercentage !== 0 && rangePercentage !== 0.00) {
              this.plan_discount_condition_otc = true
              var maxDeviationValue = parseInt(planTargetDiscount) + (parseInt(planTargetDiscount)*rangePercentage)
              if(parseFloat(contractTargetDiscount) > parseFloat(maxDeviationValue)) {
                this.item.plan_deviation_skip_approval = false
                this.plan_discount_outside_range_otc = true
                return 'text-danger';
              } else {
                this.plan_discount_outside_range_otc = null
                return 'text-muted';
              }
            }
          } else {
            this.plan_discount_condition_otc = false
            this.plan_discount_outside_range_otc = null
            return 'text-muted';
          }
        } else {
          this.plan_discount_outside_range_otc = null
        }
        return 'text-muted';
      },
      calculatePlanTargetInvestOtc() {
        var planTargetInvest = null
        if(this.item.plan_otc_target_invest !== 0 && this.item.plan_otc_target_invest !== null){
          planTargetInvest = this.item.plan_otc_target_invest
        }
        var contractTargetInvest = parseInt(this.item.marketing_activities_otc)
        if(contractTargetInvest !== 0 && planTargetInvest !== null && this.item.sales_line) {
          if(contractTargetInvest > parseInt(planTargetInvest)) {
            var rangePercentage = this.checkDifferenceAndGetPercDeviation(contractTargetInvest)
            if(rangePercentage !== null && rangePercentage !== 0 && rangePercentage !== 0.00) {
              this.plan_invest_condition_otc = true
              var maxDeviationValue = parseInt(planTargetInvest) + (parseInt(planTargetInvest)*rangePercentage)
              if(parseFloat(contractTargetInvest) > parseFloat(maxDeviationValue)) {
                this.item.plan_deviation_skip_approval = false
                this.plan_invest_outside_range_otc = true
                return 'text-danger';
              } else {
                this.plan_invest_outside_range_otc = null
                return 'text-muted';
              }
            }
          } else {
            this.plan_invest_condition_otc = false
            this.plan_invest_outside_range_otc = null
            return 'text-muted';
          }
        } else {
          this.plan_invest_outside_range_otc = null
        }
        return 'text-muted';
      },
      setTurnoverInvest () {
        var url = `/api/sandoz/sales_lines?filter[sales_line]=${this.item.type}`
        axios
          .get(url)
          .then((response) => {
            if(response.data.data && '0' in response.data.data) {
              this.item.sales_line = response.data.data[0]
              // var maximumInvest = response.data.data[0].maximum_invest
              // if(maximumInvest) {
              //   this.item.invest_turnover = parseFloat(this.getPlanDataTurnoverActual() * maximumInvest).toFixed(2)
              //   this.item.invest_turnover_percentage = maximumInvest
              // } else {
              //   this.item.invest_turnover = null
              //   this.item.invest_turnover_percentage = null
              // }
              this.$nextTick(() => {
                this.calculatePlanTurnOverExpectation()
                this.calculatePlanTargetInvest()
                this.calculatePlanTargetDiscount()
              })
            }


          })
      },
      setTurnoverExpectation () {
        var url = `/api/sandoz/sales_lines?filter[sales_line]=${this.item.type}`
        axios
          .get(url)
          .then((response) => {
            if(response.data.data && '0' in response.data.data) {
              this.item.sales_line = response.data.data[0]
              // let maximumInvestExpectation = response.data.data[0].maximum_invest_expectation
              // if(maximumInvestExpectation) {
              //   this.item.invest_growth = parseFloat(maximumInvestExpectation).toFixed(2)
              //   this.item.invest_turnover_forecast = parseFloat(this.item.growth_forecast * maximumInvestExpectation).toFixed(2)
              // } else {
              //   this.item.invest_growth = null
              //   this.item.invest_turnover_forecast = null
              // }

              this.$nextTick(() => {
                this.calculatePlanTurnOverExpectation()
                this.calculatePlanTargetInvest()
                this.calculatePlanTargetDiscount()
              })
            }
          })
      },
      checkPlanDeviationSkipApproval() {
        if( Math.sign(this.item.marketing_activities - this.priceTotal) !== -1 && (this.item.sales_line && this.item.sales_line.automatic_approval_allowed === true)
        && this.planData !== null && (
        (this.plan_turnover_expectation_condition === true || this.plan_invest_condition === true ||  this.plan_discount_condition === true || this.plan_turnover_expectation_condition_otc === true || this.plan_invest_condition_otc === true ||  this.plan_discount_condition_otc === true) &&
        (this.plan_turnover_outside_range !== true && this.plan_turnover_expectation_outside_range !== true && this.plan_invest_outside_range !== true && this.plan_discount_outside_range !== true && this.plan_turnover_outside_range_otc !== true && this.plan_turnover_expectation_outside_range_otc !== true && this.plan_invest_outside_range_otc !== true && this.plan_discount_outside_range_otc !== true)
        )
        ){
          return true
        }
        return false
      },
      isEmpty(value) {
        return value == null || value === ''
      },
      checkDiscountGXAccrual(){
        const self = this
        if(self.item.is_discount_gx_accrual && self.isEmpty(self.item.discount_gx_accrual) && self.fieldVisibility.discountGx) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.biosContract ? self.$i18n.t('sandoz.discount_bios_accrual_required') : self.$i18n.t('sandoz.discount_gx_accrual_required') }),
            type: 'error'
          })
          return true
        }
        return false
      },
      checkDiscountOTCAccrual(){
        const self = this
        if(self.item.is_discount_otc_accrual && self.isEmpty(self.item.discount_otc_accrual) && self.fieldVisibility.discountOtc) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.discount_otc_accrual_required') }),
            type: 'error'
          })
          return true
        }
        return false
      },
      setAccrual(type) {
        const self = this
        const method = 'checkDiscount' + type + 'Accrual'
        if(self[method]()) {
          return
        }

        const params = {
          item: self.item,
          type: type
        }
        self['saving'+type+'Accrual'] = true
        let url = '/api/sandoz/kam/contracts/set-accrual'
        axios.post(url, params)
          .then((response) => {
            if(response.data.success === true) {
              self.$notify({
                title: this.$i18n.t('core.saved'),
                text: this.$i18n.t('core.saved_text')
              })
              self['saving'+type+'Accrual'] = false
            }
          }).catch((error) => {
            self['saving'+type+'Accrual'] = false
        })
      },
      checkTurnOverReadonly() {
        var check = false
        if(this.readonly || (!Number.isNaN(this.item.plan_gx_turnover_actual) && !isNaN(parseFloat(this.item.plan_gx_turnover_actual)) && this.item.plan_gx_turnover_actual !== 0 && this.item.plan_gx_turnover_actual !== null)) {
          check = true
        }
        return check
      },
      checkTurnOverReadonlyOtc() {
        var check = false
        if(this.readonly || (!Number.isNaN(this.item.plan_otc_turnover_actual) && !isNaN(parseFloat(this.item.plan_otc_turnover_actual)) && this.item.plan_otc_turnover_actual !== 0 && this.item.plan_otc_turnover_actual !== null)) {
          check = true
        }
        return check
      },
      checkHeadquarter(kitem) {
        if(kitem.address_connection === "individual" && kitem.addresses.length === 1) {
          if(this.item.addresses.filter(address => address.id === kitem.addresses[0].address_id && address.address_type === 'master').length > 0) {
            return true
          }
        }
        return false
      },
      roundToWhole(value) {
        const num = Number(value)
        if (!Number.isFinite(num)) return null
        return Math.round(num)
      },
      checkKamWhs(item, tabContractVisiblity) {
        if(item.type === 'KAM_WHS' || item.type === 'BIOS_KAM_WHS'){
          if(item.contract_year >= 2026) {
            return true
          } else {
            return false
          }
        }

        return tabContractVisiblity
      }
    }
  }
</script>
<style>
.check-selected label {
  width:1px !important;
}
.has-error textarea {
  border: 1px solid red !important;
}

.mr-10 {
  margin-right: 10%;
}

.pdfFiles {
  border-bottom: none !important;
}

.pdfFiles .show-deleted-checkbox {
  text-transform: lowercase;
  font-weight: normal;
}

.bg-disable {
  background: lightgrey;
}
</style>
